<style scoped lang="scss">
#create-ms-ind {
  font-family: "Manrope";
  background: #f9f9f9;
  min-height: calc(100vh - 45px);
}
.val-dom-ques {
  display: flex;
  & .label {
  }
  & .code {
    margin-left: auto;
  }
}

.i-menu {
  display: flex;
  align-items: stretch;
  margin: 10px;

  &-item {
    margin: 0 10px 10px 10px;
    padding: 15px 20px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    cursor: pointer;
    // box-shadow:0  5px 10px rgba(154,160,185,0.05),0 15px 40px rgba(166,173,201,0.2) !important;
    border-radius: 5px;
    border: 1px solid #ced4da;
    background-color: white;
    &.selected {
      border: 1px solid #01947b !important;
      background-color: #e5fffb;
    }
    &-radio {
      position: absolute;
      right: 7px;
      top: 12px;
    }
    & .i-title {
      font-weight: 600;
      font-size: 20px;
      margin: 0;
      &-info {
        color: rgb(99, 99, 99);
        font-size: 12px;
        font-weight: 500;
        opacity: 0.85;
        letter-spacing: 0.2px;
      }
    }
    &.primary > * {
      color: #01947b;
    }
    &.secondary > * {
      color: #0277bd;
    }
    &.tertiary > * {
      color: #e91e63;
    }
    &.quaternary > * {
      color: #ff6f00;
    }
    &.quinary > * {
      color: #6a1b9a;
    }
    &.senary > * {
      color: #424242;
    }
  }
}
.i-menu > .item > .icon {
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.i-menu > .item > .icon > div {
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
}
.i-menu > .item > .title {
  font-size: 14px !important;
  font-weight: 600 !important;
  margin-bottom: auto;
  font-family: "Jakarta Plus", "Helvetica Neue", Helvetica, sans-serif;
}
.questionnaire {
  min-height: 67vh;
  display: flex;
  flex-direction: column;
  border: 1px solid #b8b8b8;
  position: relative;
  background: white;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

  &-navigation {
    display: flex;
    border-bottom: none;
    border-top: 1px solid #e0e0e0;
    // border-bottom:1px solid #e0e0e0;
    background: white;
    padding: 0px 50px 0px 50px;

    & .item {
      font-size: 13px;
      font-weight: 500;
      padding: 5px 15px;
      margin-top: -1px;
      border-left: 1px solid #e0e0e0;
      display: flex;
      align-items: center;
      &:last-child {
        border-right: 1px solid #e0e0e0;
      }
      &.active {
        // color: #2d2d2d;
        color: white;
        font-size: 13px;
        // background: #e5e5e5;
        background: #005f4f;
        // border:1px solid #005f4f;
      }
      &.invalid {
        // color: #2d2d2d;
        color: white;
        font-size: 13px;
        // background: #e5e5e5;
        background: #dc3545;
        border-color: rgb(255, 214, 214);
      }
      &.status {
        font-weight: 600;
        background: white;
        margin-left: auto;
        border: none;
        font-size: 12px;
        padding-right: 0;
        & div {
          border-radius: 5px;
          padding: 1px 3px;
        }
        & .draft {
          background-color: #cccccc;
          color: #424242;
          border: 1px solid #cccccc;
        }

        & .submitted {
          color: #1976d2;
          background: #e3f2fd;
          border: 1px solid #90caf9;

          &.darker {
            background: #006aff;
            color: white;
          }
        }
        & .under-review {
          color: #7b6400;
          background: #ffe600;
          border: 1px solid #d8c300;
        }
        & .correction-required,
        &.revised {
          color: #7b1fa2;
          background: #f3e5f5;
          border: 1px solid #ce93d8;
        }
        & .rejected {
          background: rgb(253, 208, 208);
          color: rgb(201, 0, 0);
          border: 1px solid rgb(255, 143, 143);
        }
        & .approved {
          font-weight: 600;
          background: #c4ffc4;
          color: rgb(22, 139, 22);
          border: 1px solid rgb(97, 213, 97);
        }
        & .published {
          font-weight: 500;
          background: rgb(192, 255, 192);
          color: rgb(25, 136, 25);
          border: 1px solid rgb(154, 234, 154);
        }
      }
      & .count {
        margin-left: 2px;
        // background: #dadada;
        // color:#212121;
        // border-radius:4px;
        // padding:2px 4px;
        // font-size:11px;
        // display:flex;
        // justify-content:center;
        // align-items:center;
      }
    }

    & .button-navigation {
      & .prev {
        padding: 5px 15px;
      }
      & .next {
        padding: 5px 15px;
        background: teal;
        color: white;
      }
    }
  }
  &.entry-mode {
    & .blok-detail {
      padding: 20px 25px;

      & .question {
        border: none !important;
      }
    }
  }
  & .blok {
    & .blok-title {
      color: #2d2d2d;
      font-size: 14px;
      font-weight: 700;
      background: #e5e5e5;
      padding: 0.25rem 0.5rem;
      text-align: center;

      border-top: 1px solid #b8b8b8;
      border-bottom: 1px solid #b8b8b8;
      text-transform: uppercase;
    }
    &:first-child .blok-title {
      border-top: none;
    }
  }
  & .blok-detail {
    padding: 20px 25px;

    & .question {
      padding: 10px 0px;
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 0;
      }
      &:not(:last-child) {
        border-bottom: 1px solid rgb(210, 210, 210);
      }
      &__name {
        font-size: 13px;
        font-weight: 700;
        margin-bottom: 0rem;
        color: #212121;
      }
      &__value {
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 0rem;
        color: #525252;

        & input,
        & .vue-treeselect,
        & textarea,
        & div[role="radiogroup"],
        & ul {
          margin-top: 3px !important;
        }
        & div[role="radiogroup"] {
          margin-left: 3px !important;
        }
        & .custom-checkbox {
          margin-left: 3px !important;
        }
      }
      & ul.list {
        list-style-type: none;
        margin-left: -40px;
        margin-bottom: 0;

        & li::before {
          content: "-";
          margin-right: 5px;
        }
        & li:only-child {
          margin-left: 1px;
          &::before {
            content: "";
            margin-right: 0px;
          }
        }
      }
    }

    & p.question {
      font-size: 13px;
      font-weight: 700;
      margin-bottom: 0rem;
      color: #212121;
    }
    & p {
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 0rem;
      color: #525252;
    }
  }
  &__status {
    margin-top: -7px;
    margin-left: 4px;
    padding: 3px 5px;
    letter-spacing: 0.3px;
    font-size: 12px;
    border-radius: 5px 0px 5px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: rgb(251, 229, 229);
    border: 1px solid #cccccc;
    background-color: #cccccc;
    color: #424242;

    &2 {
      border-radius: 0px 0px 0px 15px;
      position: absolute;
      top: -1px;
      right: -1px;
      padding: 5px 10px;
    }
    &3 {
      margin-top: 0px;
      margin-left: 0px;
      font-weight: 600;
      padding: 3px 5px;
    }
    &.draft,
    &2.draft,
    &3.draft {
      color: #424242;
      background: #cccccc;
      border: 1px solid #bbbbbb;
    }
    &.submitted,
    &2.submitted,
    &3.submitted {
      color: #1976d2;
      background: #e3f2fd;
      border: 1px solid #90caf9;

      &.darker {
        background: #006aff;
        color: white;
      }
    }
    &.under-review,
    &2.under-review,
    &3.under-review {
      // font-weight: 600;
      // border: 1px solid #cca600;
      // background: #fffae6;
      // color: #745e00;

      font-weight: 600;
      color: #8c7200;
      background: #fff27d;
      border: 1px solid #dfcd2b;
    }
    &.correction-required,
    &.revised,
    &2.correction-required,
    &2.revised,
    &3.correction-required,
    &3.revised {
      color: #7b1fa2;
      background: #f3e5f5;
      border: 1px solid #ce93d8;
    }
    &.rejected,
    &2.rejected,
    &3.rejected {
      background: rgb(253, 208, 208);
      color: rgb(201, 0, 0);
      border: 1px solid rgb(255, 143, 143);
    }
    &.approved,
    &2.approved,
    &3.approved {
      font-weight: 600;
      background: #c4ffc4;
      color: rgb(22, 139, 22);
      border: 1px solid rgb(97, 213, 97);
    }
    &.published,
    &2.published,
    &3.published {
      font-weight: 500;
      background: rgb(192, 255, 192);
      color: rgb(25, 136, 25);
      border: 1px solid rgb(154, 234, 154);
    }
  }
  &__body {
    flex-direction: column;
    display: flex;
    flex-grow: 1;
  }
  &__footer {
    border-top: 1px solid #b8b8b8;
    bottom: 0;
    display: flex;
    padding: 10px 20px;
  }
}


/* ============================================================
   History Status (ms_keg_histories)
   ============================================================ */
.history-status {
  margin-top: 12px;

  &__item {
    padding: 8px 10px;
    margin-bottom: 8px;
    border-left: 3px solid #e0e0e0;
    background: #fafafa;
    border-radius: 4px;
  }

  &__number {
    font-size: 11px;
    font-weight: 600;
    color: #424242;
    min-width: 18px;
  }

  &__badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .3px;
    border: 1px solid transparent;

    &--draft {
      color: #424242;
      background: #cccccc;
      border-color: #bbbbbb;
    }
    &--submitted {
      color: #1976d2;
      background: #e3f2fd;
      border-color: #90caf9;
    }
    &--under-review {
      font-weight: 600;
      color: #8c7200;
      background: #fff27d;
      border-color: #dfcd2b;
    }
    &--correction-required,
    &--revised {
      color: #7b1fa2;
      background: #f3e5f5;
      border-color: #ce93d8;
    }
    &--rejected {
      background: rgb(253, 208, 208);
      color: rgb(201, 0, 0);
      border-color: rgb(255, 143, 143);
    }
    &--approved {
      font-weight: 600;
      background: #c4ffc4;
      color: rgb(22, 139, 22);
      border-color: rgb(97, 213, 97);
    }
    &--published {
      font-weight: 500;
      background: rgb(192, 255, 192);
      color: rgb(25, 136, 25);
      border-color: rgb(154, 234, 154);
    }
  }

  &__info {
    font-size: 10px;
    color: #757575;
    margin-top: 4px;
    margin-left: 18px;
    font-style: italic;
  }

  &__rejection {
    font-size: 11px;
    color: #c9302c;
    margin-top: 4px;
    margin-left: 18px;
    padding: 4px 6px;
    background: #fff5f5;
    border-radius: 3px;
    border: 1px solid #f5c6cb;
  }
}
</style>
<style>
td span:not(:first-child) .mx-datepicker {
  margin-top: 8px !important;
}
</style>
<template>
  <div id="create-ms-ind">
    <div class="page-control--secondary">
      <div class="page-control__body">
        <div class="page-control__left">
          <button
            class="button button--text button--action mr-2"
            id="backUsulanList"
            @click="$router.back()"
          >
            <VueFeather
              type="arrow-left"
              size="18"
              stroke-width="1.5"
              style="display: block"
            ></VueFeather>
          </button>
          <b-popover
            target="backUsulanList"
            triggers="hover"
            placement="bottom"
          >
            <template #title>Kembali ke halaman daftar usulan</template>
            Pastikan anda sudah menyimpan isian terlebih dahulu dengan klik
            tombol draft atau submit, karena ketika kembali isian ada akan
            hilang
          </b-popover>
          <div class="my-1">
            <div
              class="d-flex align-items-start"
              style="
                font-family: 'Manrope';
                font-weight: 600;
                font-size: 16px;
                color: #032f05;
                line-height: 1;
              "
            >
              <div>
                Pemeriksaan Metadata Kegiatan
                <span class="text-primary">{{ data.judul_kegiatan }}</span>
              </div>
            </div>
            <div
              class=""
              style="
                font-family: 'Manrope';
                font-weight: 500;
                font-size: 12px;
                color: #515151;
              "
            >
              Harap baca panduan terlebih dahulu, agar pelaporan Anda dapat
              menjadi lebih mudah.
            </div>
          </div>
        </div>
        <div class="page-control__center"></div>
        <div
          class="page-control__right align-items-center"
          v-if="tab.index == 0"
        >
          <button
            class="button"
            variant="primary"
            size="sm"
            @click="
              () => {
                $bvModal.show('modal-approval');
              }
            "
          >
            <VueFeather
              type="send"
              size="14"
              stroke-width="2"
              style="display: block"
            ></VueFeather
            >&nbsp;&nbsp;Simpan
          </button>
        </div>
      </div>
      <div class="page-control__footer">
        <div class="questionnaire-navigation">
          <div
            class="item"
            :class="tab.index == index ? 'active' : ''"
            v-for="(item, index) in tab.items"
            :key="index"
            @click="tabIndexChanged(index)"
          >
            {{ item.name }}
            <span v-if="index != 0" class="count">({{ item.count }})</span>
          </div>
        </div>
      </div>
    </div>

    <div class="content content--borderless">
      <div v-if="isLoading" class="content__loading">
        <img
          src="@/assets/icons/loading-plane.gif"
          width="200"
          height="200"
          style="margin-top: -60px"
        />
        <div style="margin-top: -60px">
          Sedang mengambil data ke server, harap tunggu sebentar....
        </div>
      </div>
      <div v-else class="content__body" style="margin: 20px 65px">
        <b-tabs
          v-model="tab.index"
          nav-class="d-none"
          content-class="p-0"
          v-if="msKeg"
        >
          <b-tab>
            <b-row class="h-100p">
              <b-col id="form" cols="8" class="form form--sm h-100p px-0">
                <div class="questionnaire">
                  <div
                    :class="
                      'questionnaire__status2 ' +
                      statusFormatterStyle(form.status)
                    "
                    v-if="!['DRAFT', 'SUBMITTED'].includes(form.status)"
                  >
                    {{ statusFormatter(form.status) }}
                  </div>
                  <div class="blok">
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">Judul Kegiatan :</div>
                        <div class="question__value">
                          {{ capitalize(data.judul_kegiatan) }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">Tahun:</div>
                        <div class="question__value">
                          {{ data.tahun }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">Cara Pengumpulan Data:</div>
                        <div class="question__value">
                          {{ capitalize(data.cara_pengumpulan_data) }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">Sektor Kegiatan:</div>
                        <div class="question__value">
                          {{ capitalize(data.sektor_kegiatan) }}
                        </div>
                      </div>
                      <div
                        class="question"
                        v-if="form.jenis_statistik == 'STATISTIK_SEKTORAL'"
                      >
                        <div class="question__name">
                          Apakah mendapatkan rekomendasi kegiatan statistik dari
                          BPS?
                        </div>
                        <div class="question__value">
                          {{
                            capitalize(
                              data.identitas_rekomendasi ? "Ya" : "Tidak"
                            )
                          }}
                        </div>
                        <div
                          class="question__name mt-2"
                          v-if="data.identitas_rekomendasi"
                        >
                          Identitas Rekomendasi:
                        </div>
                        <div
                          class="question__value"
                          v-if="data.identitas_rekomendasi"
                        >
                          {{ capitalize(data.identitas_rekomendasi) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="blok_i" class="blok">
                    <div class="blok-title">I. Penyelenggara</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">
                          1.1. Instansi Penyelenggara:
                        </div>
                        <div class="question__value">
                          {{ capitalize(data.blok_i.instansi_penyelanggara) }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          1.2. Alamat Lengkap Instansi Penyelenggara:
                        </div>
                        <div class="question__value">
                          {{
                            capitalize(
                              data.blok_i.alamat_instansi_penyelenggara.alamat
                            )
                          }}
                        </div>
                        <b-row class="mt-2">
                          <b-col>
                            <div class="question">
                              <div class="question__name">Telepon:</div>
                              <div class="question__value">
                                {{
                                  capitalize(
                                    data.blok_i.alamat_instansi_penyelenggara
                                      .telepon
                                  )
                                }}
                              </div>
                            </div>
                          </b-col>
                          <b-col>
                            <div class="question">
                              <div class="question__name">Faksmile:</div>
                              <div class="question__value">
                                {{
                                  capitalize(
                                    data.blok_i.alamat_instansi_penyelenggara
                                      .faksimile
                                  )
                                }}
                              </div>
                            </div>
                          </b-col>
                          <b-col>
                            <div class="question">
                              <div class="question__name">Email:</div>
                              <div class="question__value">
                                {{
                                  capitalize(
                                    data.blok_i.alamat_instansi_penyelenggara
                                      .email
                                  )
                                }}
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>

                  <div id="blok_ii" class="blok">
                    <div class="blok-title">II. Penanggung Jawab</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">
                          2.1. Unit Eselon Penanggung Jawab:
                        </div>
                        <b-row class="mt-2">
                          <b-col>
                            <div class="question">
                              <div class="question__name">Eselon 1:</div>
                              <div class="question__value">
                                {{
                                  capitalize(
                                    data.blok_ii.unit_penanggung_jawab.eselon1
                                  )
                                }}
                              </div>
                            </div>
                          </b-col>
                          <b-col>
                            <div class="question">
                              <div class="question__name">Eselon 2:</div>
                              <div class="question__value">
                                {{
                                  capitalize(
                                    data.blok_ii.unit_penanggung_jawab.eselon2
                                  )
                                }}
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          2.2. Penanggung Jawab Teknis (setingkat Eselon 3):
                        </div>
                        <div class="question">
                          <div class="question__name">Nama:</div>
                          <div class="question__value">
                            {{
                              capitalize(
                                data.blok_ii.penanggung_jawab_teknis.nama
                              )
                            }}
                          </div>

                          <div class="question__name mt-2">Jabatan:</div>
                          <div class="question__value">
                            {{
                              capitalize(
                                data.blok_ii.penanggung_jawab_teknis.jabatan
                              )
                            }}
                          </div>

                          <div class="question__name mt-2">Alamat:</div>
                          <div class="question__value">
                            {{
                              capitalize(
                                data.blok_ii.penanggung_jawab_teknis.alamat
                              )
                            }}
                          </div>

                          <b-row class="mt-2">
                            <b-col>
                              <div class="question__name">Telepon:</div>
                              <div class="question__value">
                                {{
                                  capitalize(
                                    data.blok_ii.penanggung_jawab_teknis.telepon
                                  )
                                }}
                              </div>
                            </b-col>
                            <b-col>
                              <div class="question__name">Faksmile:</div>
                              <div class="question__value">
                                {{
                                  capitalize(
                                    data.blok_ii.penanggung_jawab_teknis
                                      .faksimile
                                  )
                                }}
                              </div>
                            </b-col>
                            <b-col>
                              <div class="question__name">Email:</div>
                              <div class="question__value">
                                {{
                                  capitalize(
                                    data.blok_ii.penanggung_jawab_teknis.email
                                  )
                                }}
                              </div>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="blok_iii" class="blok">
                    <div class="blok-title">III. Perencanaan dan Persiapan</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">
                          3.1. Latar Belakang Kegiatan:
                        </div>
                        <div class="question__value">
                          {{
                            capitalize(data.blok_iii.latar_belakang_kegiatan)
                          }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">3.2. Tujuan Kegiatan:</div>
                        <div class="question__value">
                          {{ capitalize(data.blok_iii.tujuan_kegiatan) }}
                        </div>
                      </div>
                      <div class="question border-bottom-0">
                        <div class="question__name">
                          3.3. Rencana Jadwal Kegiatan:
                        </div>
                        <div class="table-wrapper mt-2">
                          <table class="table table--light table--bordered">
                            <thead>
                              <tr>
                                <th colspan="2"></th>
                                <th class="text-center">Tanggal Mulai</th>
                                <th class="text-center">Tanggal Selesai</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  class="text-bold text-right w-max-25 w-26"
                                  style="
                                    border-right: 0 !important;
                                    padding-right: 0 !important;
                                  "
                                >
                                  A.
                                </td>
                                <td colspan="3" class="text-bold">
                                  Perencanaan
                                </td>
                              </tr>
                              <tr>
                                <td style="border-right: 0 !important"></td>
                                <td class="pl-2">
                                  1. &nbsp;Perencanaan Kegiatan
                                </td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan
                                      .perencanaan_kegiatan"
                                    v-bind:key="index"
                                  >
                                    {{ item.awal | formatDate }}
                                  </div>
                                </td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan
                                      .perencanaan_kegiatan"
                                    v-bind:key="index"
                                  >
                                    {{ item.akhir | formatDate }}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td style="border-right: 0 !important"></td>
                                <td class="sub-title">2. &nbsp;Desain</td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan.desain"
                                    v-bind:key="index"
                                  >
                                    {{ item.awal | formatDate }}
                                  </div>
                                </td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan.desain"
                                    v-bind:key="index"
                                  >
                                    {{ item.akhir | formatDate }}
                                  </div>
                                </td>
                              </tr>
                              <tr class="text-bold">
                                <td
                                  class="text-right"
                                  style="
                                    border-right: 0 !important;
                                    padding-right: 0 !important;
                                  "
                                >
                                  B.
                                </td>
                                <td colspan="3">Pengumpulan</td>
                              </tr>
                              <tr>
                                <td style="border-right: 0 !important"></td>
                                <td class="sub-title">
                                  3. &nbsp;Pengumpulan Data
                                </td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan.pengumpulan_data"
                                    v-bind:key="index"
                                  >
                                    {{ item.awal | formatDate }}
                                  </div>
                                </td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan.pengumpulan_data"
                                    v-bind:key="index"
                                  >
                                    {{ item.akhir | formatDate }}
                                  </div>
                                </td>
                              </tr>
                              <tr class="text-bold">
                                <td
                                  class="text-right"
                                  style="
                                    border-right: 0 !important;
                                    padding-right: 0 !important;
                                  "
                                >
                                  C.
                                </td>
                                <td colspan="3">Pemeriksaan</td>
                              </tr>
                              <tr>
                                <td style="border-right: 0 !important"></td>
                                <td class="sub-title">
                                  4. &nbsp;Pengolahan Data
                                </td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan.pengolahan_data"
                                    v-bind:key="index"
                                  >
                                    {{ item.awal | formatDate }}
                                  </div>
                                </td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan.pengolahan_data"
                                    v-bind:key="index"
                                  >
                                    {{ item.akhir | formatDate }}
                                  </div>
                                </td>
                              </tr>
                              <tr class="text-bold">
                                <td
                                  class="text-right"
                                  style="
                                    border-right: 0 !important;
                                    padding-right: 0 !important;
                                  "
                                >
                                  D.
                                </td>
                                <td colspan="3">Penyebarluasan</td>
                              </tr>
                              <tr>
                                <td style="border-right: 0 !important"></td>
                                <td class="sub-title">5. &nbsp;Analisis</td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan.analisis"
                                    v-bind:key="index"
                                  >
                                    {{ item.awal | formatDate }}
                                  </div>
                                </td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan.analisis"
                                    v-bind:key="index"
                                  >
                                    {{ item.akhir | formatDate }}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td style="border-right: 0 !important"></td>
                                <td class="sub-title">
                                  6. &nbsp;Diseminasi Hasil
                                </td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan.diseminasi_hasil"
                                    v-bind:key="index"
                                  >
                                    {{ item.awal | formatDate }}
                                  </div>
                                </td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan.diseminasi_hasil"
                                    v-bind:key="index"
                                  >
                                    {{ item.akhir | formatDate }}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td style="border-right: 0 !important"></td>
                                <td class="sub-title">7. &nbsp;Evaluasi</td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan.evaluasi"
                                    v-bind:key="index"
                                  >
                                    {{ item.awal | formatDate }}
                                  </div>
                                </td>
                                <td class="text-center">
                                  <div
                                    class="mb-0"
                                    v-for="(item, index) in data.blok_iii
                                      .rencana_jadwal_kegiatan.evaluasi"
                                    v-bind:key="index"
                                  >
                                    {{ item.akhir | formatDate }}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          3.4. Variabel (Karakteristik) yang Dikumpulkan:
                        </div>
                        <div class="table-wrapper mt-2">
                          <b-table
                            class="table--light table--bordered"
                            :items="data.blok_iii.variabel_yang_dikumpulkan"
                            :fields="[
                              {
                                key: 'no',
                                thClass: 'w-40',
                                tdClass: 'text-center',
                              },
                              {
                                key: 'nama',
                                label: 'Nama Variabel (Kharakteristik)',
                                thClass: '',
                              },
                              'konsep',
                              'definisi',
                              {
                                key: 'referensi_waktu',
                                label: 'Referensi Waktu (periode Enumerasi)',
                                thClass: '',
                              },
                            ]"
                          >
                            <template #cell(no)="data">
                              {{ data.index + 1 }}.
                            </template>
                            <template #empty>
                              <div class="table__empty">
                                <div>
                                  <VueFeather
                                    type="alert-circle"
                                    size="18"
                                  ></VueFeather>
                                  &nbsp; Variabel belukm diinput
                                </div>
                              </div>
                            </template>
                          </b-table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="blok_iv" class="blok">
                    <div class="blok-title">IV. Desain Kegiatan</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">
                          4.1. Kegiatan Ini Dilakukan:
                        </div>
                        <div class="question__value">
                          {{ capitalize(data.blok_iv.kegiatan_ini_dilakukan) }}
                        </div>
                      </div>

                      <div
                        class="question"
                        v-if="data.blok_iv.kegiatan_ini_dilakukan == 'BERULANG'"
                      >
                        <div class="question__name">
                          4.2. Frekuensi Penyelenggaraan:
                        </div>
                        <div class="question__value">
                          {{ capitalize(data.blok_iv.frekuensi_penyelanggara) }}
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">
                          4.3. Tipe Pengumpulan Data:
                        </div>
                        <div class="question__value">
                          {{ capitalize(data.blok_iv.tipe_pengumpulan_data) }}
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">
                          4.4. Cakupan Wilayah Pengumpulan Data:
                        </div>
                        <div class="question__value">
                          {{
                            capitalize(
                              data.blok_iv.cakupan_wilayah_pengumpulan_data
                            )
                          }}
                        </div>
                      </div>

                      <div
                        class="question border-bottom-0"
                        v-if="
                          data.blok_iv.cakupan_wilayah_pengumpulan_data ==
                          'SEBAGIAN_WILAYAH_INDONESIA'
                        "
                      >
                        <div class="question__name">4.5. Wilayah Kegiatan:</div>
                        <div class="table-wrapper mt-2">
                          <b-table
                            class="table--light table--bordered"
                            :items="
                              data.blok_iv
                                .sebagian_cakupan_wilayah_pengumpulan_data
                            "
                            :fields="[
                              { key: 'no', class: 'w-30 text-center' },
                              'nama_provinsi',
                              'nama_kabupaten_kota',
                            ]"
                          >
                            <template #cell(no)="data">
                              {{ data.index + 1 }}.
                            </template>
                          </b-table>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">
                          4.6. Metode Pengumpulan Data:
                        </div>
                        <div class="question__value">
                          <ul class="list">
                            <li
                              v-if="
                                data.blok_iv.metode_pengumpulan_data.wawancara
                              "
                            >
                              Wawancara
                            </li>
                            <li
                              v-if="
                                data.blok_iv.metode_pengumpulan_data
                                  .mengisi_kuesioner_sendiri
                              "
                            >
                              Mengisi Kuesioner Sendiri
                            </li>
                            <li
                              v-if="
                                data.blok_iv.metode_pengumpulan_data.pengamatan
                              "
                            >
                              Pengamatan
                            </li>
                            <li
                              v-if="
                                data.blok_iv.metode_pengumpulan_data
                                  .pengumpulan_data_sekunder
                              "
                            >
                              Pengumpulan Data Sekunder
                            </li>
                            <li
                              v-if="
                                data.blok_iv.metode_pengumpulan_data.lainnya
                              "
                            >
                              Lainnya :
                              {{
                                data.blok_iv.metode_pengumpulan_data
                                  .metode_pengumpulan_lainnya
                              }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          4.7. Sarana Pengumpulan Data:
                        </div>
                        <div class="question__value">
                          <ul class="list">
                            <li
                              v-if="data.blok_iv.sarana_pengumpulan_data.papi"
                            >
                              Paper-assisted Personal Interviewing (PAPI)
                            </li>
                            <li
                              v-if="data.blok_iv.sarana_pengumpulan_data.capi"
                            >
                              Computer-assisted Personal Interviewing (CAPI)
                            </li>
                            <li
                              v-if="data.blok_iv.sarana_pengumpulan_data.cati"
                            >
                              Computer-assisted Telephones Interviewing (CATI)
                            </li>
                            <li
                              v-if="data.blok_iv.sarana_pengumpulan_data.cawi"
                            >
                              Computer Aided Web Interviewing (CAWI)
                            </li>
                            <li
                              v-if="data.blok_iv.sarana_pengumpulan_data.mail"
                            >
                              Mail
                            </li>
                            <li
                              v-if="
                                data.blok_iv.sarana_pengumpulan_data.lainnya
                              "
                            >
                              Lainnya :
                              {{
                                data.blok_iv.sarana_pengumpulan_data
                                  .sarana_pengumpulan_lainnya
                              }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          4.8. Unit Pengumpulan Data:
                        </div>
                        <div class="question__value">
                          <ul class="list">
                            <li
                              v-if="data.blok_iv.unit_pengumpulan_data.individu"
                            >
                              Individu
                            </li>
                            <li
                              v-if="
                                data.blok_iv.unit_pengumpulan_data.rumah_tangga
                              "
                            >
                              Rumah Tangga
                            </li>
                            <li
                              v-if="
                                data.blok_iv.unit_pengumpulan_data
                                  .usaha_atau_perusahaan
                              "
                            >
                              Usaha/Perusahaan
                            </li>
                            <li
                              v-if="data.blok_iv.unit_pengumpulan_data.lainnya"
                            >
                              Lainnya :
                              {{
                                data.blok_iv.unit_pengumpulan_data
                                  .unit_pengumpulan_data_lainnya
                              }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="blok_v" class="blok">
                    <div
                      class="blok-title"
                      v-if="data.cara_pengumpulan_data == 'SURVEI'"
                    >
                      <div>V. Desain Sampel</div>
                      <div
                        class="text-12 text-semi-bold"
                        style="text-transform: none"
                      >
                        Diisi jika cara pengumpulan data adalah Survei
                      </div>
                    </div>
                    <div
                      class="blok-detail"
                      v-if="data.cara_pengumpulan_data == 'SURVEI'"
                    >
                      <div class="question">
                        <div class="question__name">
                          5.1. Jenis Rancangan Sampel:
                        </div>
                        <div class="question__value">
                          {{ capitalize(data.blok_v.jenis_rancangan_sampel) }}
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">
                          5.2. Metode Pemilihan Sampel Tahap Terakhir:
                        </div>
                        <div class="question__value">
                          {{
                            capitalize(
                              data.blok_v.metode_pemilihan_sampel_tahap_terakhir
                            )
                          }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          5.3. Metode Yang Digunakan:
                        </div>
                        <div class="question__value">
                          {{ capitalize(data.blok_v.metode_yang_digunakan) }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          5.4. Kerangka Sampel Tahap Terakhir:
                        </div>
                        <div class="question__value">
                          {{
                            capitalize(
                              data.blok_v.kerangka_sampel_tahap_terakhir
                            )
                          }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          5.5. Fraksi Sampel Keseluruhan:
                        </div>
                        <div class="question__value">
                          {{
                            capitalize(data.blok_v.fraksi_sampel_keseluruhan)
                          }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          5.6. Nilai Perkiraan Sampling Error Variabel Utama:
                        </div>
                        <div class="question__value">
                          {{
                            capitalize(
                              data.blok_v
                                .nilai_perkiraan_sampling_error_variabel_utama
                            )
                          }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">5.7. Unit Sampel:</div>
                        <div class="question__value">
                          {{ capitalize(data.blok_v.unit_sampel) }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">5.8. Unit Observasi:</div>
                        <div class="question__value">
                          {{ capitalize(data.blok_v.unit_observasi) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="blok_vi" class="blok">
                    <div class="blok-title">VI. Pengumpulan Data</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">
                          6.1. Apakah Melakukan Uji Coba (Pilot Survey)?
                        </div>
                        <div class="question__value">
                          {{
                            data.blok_vi.apakah_melakukan_uji_coba == true
                              ? "Ya"
                              : "Tidak"
                          }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          6.2. Metode Pemeriksaan Kualitas Pengumpulan Data:
                        </div>
                        <div class="question__value">
                          <ul class="list">
                            <li
                              v-if="
                                data.blok_vi
                                  .metode_pemeriksaan_kualitas_pengumpulan_data
                                  .kunjungan_kembali
                              "
                            >
                              Kunjungan Kembali
                            </li>
                            <li
                              v-if="
                                data.blok_vi
                                  .metode_pemeriksaan_kualitas_pengumpulan_data
                                  .supervisi
                              "
                            >
                              Supervisi
                            </li>
                            <li
                              v-if="
                                data.blok_vi
                                  .metode_pemeriksaan_kualitas_pengumpulan_data
                                  .taskforce
                              "
                            >
                              Task Force
                            </li>
                            <li
                              v-if="
                                data.blok_vi
                                  .metode_pemeriksaan_kualitas_pengumpulan_data
                                  .lainnya
                              "
                            >
                              Lainnya:
                              {{
                                data.blok_vi
                                  .metode_pemeriksaan_kualitas_pengumpulan_data
                                  .metode_pemeriksaan_kualitas_pengumpulan_data_lainnya
                              }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          6.3. Apakah Melakukan Penyesuaian Nonrespon?
                        </div>
                        <div class="question__value">
                          {{
                            data.blok_vi
                              .apakah_melakukan_penyesuaian_nonrespon == true
                              ? "Ya"
                              : "Tidak"
                          }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          6.4. Petugas Pengumpulan Data:
                        </div>
                        <div class="question__value">
                          {{
                            capitalize(data.blok_vi.petugas_pengumpulan_data)
                          }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          6.5. Persyaratan Pendidikan Terendah Petugas
                          Pengumpulan Data:
                        </div>
                        <div class="question__value">
                          {{
                            capitalize(
                              data.blok_vi
                                .persyaratan_pendidikan_terendah_petugas_pengumpulan_data
                            )
                          }}
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">6.6. Jumlah Petugas:</div>
                        <div>
                          <div class="d-flex">
                            <div class="question__value w-200">
                              Supervisor/penyelia/pengawas
                            </div>
                            <div class="question__value">
                              :
                              {{ data.blok_vi.jumlah_petugas_supervisor }} orang
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="question__value w-200">
                              Pengumpul data/enumerator
                            </div>
                            <div class="question__value">
                              :
                              {{ data.blok_vi.jumlah_petugas_enumerator }} orang
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">
                          6.7. Apakah Melakukan Pelatihan Petugas?
                        </div>
                        <div class="question__value">
                          {{
                            data.blok_vi.apakah_melakukan_pelatihan_petugas
                              ? "Ya"
                              : "Tidak"
                          }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="blok_vii" class="blok">
                    <div class="blok-title">VII. Pengolahan Dan Analisis</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">
                          7.1. Tahapan Pengolahan Data:
                        </div>
                        <div>
                          <div class="d-flex">
                            <div class="question__value w-200">
                              Penyuntingan (Editing)
                            </div>
                            <div class="question__value">
                              :
                              {{
                                data.blok_vii.tahapan_pengolahan_data.editing
                                  ? "Ya"
                                  : "Tidak"
                              }}
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="question__value w-200">
                              Penyandian (Coding)
                            </div>
                            <div class="question__value">
                              :
                              {{
                                data.blok_vii.tahapan_pengolahan_data.coding
                                  ? "Ya"
                                  : "Tidak"
                              }}
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="question__value w-200">Data Entry</div>
                            <div class="question__value">
                              :
                              {{
                                data.blok_vii.tahapan_pengolahan_data.data_entry
                                  ? "Ya"
                                  : "Tidak"
                              }}
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="question__value w-200">
                              Penyahihan (Validasi)
                            </div>
                            <div class="question__value">
                              :
                              {{
                                data.blok_vii.tahapan_pengolahan_data.validasi
                                  ? "Ya"
                                  : "Tidak"
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="question">
                        <div class="question__name">7.2. Metode Analisis:</div>
                        <div class="question__value">
                          {{ capitalize(data.blok_vii.metode_analisis) }}
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">7.3. Unit Analisis:</div>
                        <div class="question__value">
                          <ul class="list">
                            <li v-if="data.blok_vii.unit_analsis.individu">
                              Individu
                            </li>
                            <li v-if="data.blok_vii.unit_analsis.rumah_tangga">
                              Rumah Tangga
                            </li>
                            <li
                              v-if="
                                data.blok_vii.unit_analsis.usaha_atau_perusahaan
                              "
                            >
                              Usaha/Perusahaan
                            </li>
                            <li v-if="data.blok_vii.unit_analsis.lainnya">
                              Lainnya:
                              {{
                                data.blok_vii.unit_analsis.unit_analisis_lainnya
                              }}
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">
                          7.4. Tingkat Penyajian Hasil Analisis:
                        </div>
                        <div class="question__value">
                          <ul class="list">
                            <li
                              v-if="
                                data.blok_vii.tingkat_penyajian_hasil_analisis
                                  .nasional
                              "
                            >
                              Nasional
                            </li>
                            <li
                              v-if="
                                data.blok_vii.tingkat_penyajian_hasil_analisis
                                  .provinsi
                              "
                            >
                              Provinsi
                            </li>
                            <li
                              v-if="
                                data.blok_vii.tingkat_penyajian_hasil_analisis
                                  .kabupaten_atau_kota
                              "
                            >
                              Kabupaten/Kota
                            </li>
                            <li
                              v-if="
                                data.blok_vii.tingkat_penyajian_hasil_analisis
                                  .lainnya
                              "
                            >
                              Lainnya:
                              {{
                                data.blok_vii.tingkat_penyajian_hasil_analisis
                                  .tingkat_penyajian_hasil_analisis_lainnya
                              }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div id="blok_viii" class="blok">
                    <div class="blok-title">VIII. Diseminasi Hasil</div>
                    <div class="blok-detail">
                      <div class="question">
                        <div class="question__name">
                          8.1. Produk Kegiatan yang Tersedia untuk Umum
                        </div>
                        <div>
                          <div class="d-flex">
                            <div class="question__value w-200">
                              Tercetak (Hardcopy)
                            </div>
                            <div class="question__value">
                              :
                              {{
                                data.blok_viii.ketersediaan_produk_tercetak
                                  ? "Ya"
                                  : "Tidak"
                              }}
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="question__value w-200">
                              Digital (Softcopy)
                            </div>
                            <div class="question__value">
                              :
                              {{
                                data.blok_viii.ketersediaan_produk_digital
                                  ? "Ya"
                                  : "Tidak"
                              }}
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="question__value w-200">Data Mikro</div>
                            <div class="question__value">
                              :
                              {{
                                data.blok_viii.ketersediaan_produk_mikrodata
                                  ? "Ya"
                                  : "Tidak"
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="question"
                        v-if="
                          (data.blok_viii
                            .rencana_jadwal_rilis_produk_tercetak &&
                            data.blok_viii.rencana_jadwal_rilis_produk_tercetak
                              .length > 0) ||
                          (data.blok_viii.rencana_jadwal_rilis_produk_digital &&
                            data.blok_viii.rencana_jadwal_rilis_produk_digital
                              .length > 0) ||
                          (data.blok_viii
                            .rencana_jadwal_rilis_produk_mikrodata &&
                            data.blok_viii.rencana_jadwal_rilis_produk_mikrodata
                              .length > 0)
                        "
                      >
                        <div class="question__name">
                          8.2. Rencana Rilis Produk Kegiatan
                        </div>
                        <div class="question__value">
                          <div class="table-wrapper mt-2">
                            <table class="table table--light table--bordered">
                              <thead>
                                <tr>
                                  <th class="w-200 text-left">Jenis Produk</th>
                                  <th class="text-center">Tanggal Rilis</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Tercetak (Hardcopy)</td>
                                  <td class="text-center">
                                    <span
                                      v-for="(item, index) in data.blok_viii
                                        .rencana_jadwal_rilis_produk_tercetak"
                                      v-bind:key="index"
                                    >
                                      {{ item | formatDate }}
                                      <span
                                        v-if="
                                          data.blok_viii
                                            .rencana_jadwal_rilis_produk_tercetak
                                            .length > 1
                                        "
                                        >,</span
                                      >
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Digital (Softcopy)</td>
                                  <td class="text-center">
                                    <span
                                      v-for="(item, index) in data.blok_viii
                                        .rencana_jadwal_rilis_produk_digital"
                                      v-bind:key="index"
                                    >
                                      {{ item | formatDate }}
                                      <span
                                        v-if="
                                          data.blok_viii
                                            .rencana_jadwal_rilis_produk_digital
                                            .length > 1
                                        "
                                        >,</span
                                      >
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>Data Mikro</td>
                                  <td class="text-center">
                                    <span
                                      v-for="(item, index) in data.blok_viii
                                        .rencana_jadwal_rilis_produk_mikrodata"
                                      v-bind:key="index"
                                    >
                                      {{ item | formatDate }}
                                      <span
                                        v-if="
                                          data.blok_viii
                                            .rencana_jadwal_rilis_produk_mikrodata
                                            .length > 1
                                        "
                                        >,</span
                                      >
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col id="review" cols="4" class="pr-0 mr-0">
                <div
                  class="review my-0 mx-0"
                  style="top: 147px; height: calc(100vh - 160px)"
                >
                  <div class="review__header">
                    <div class="review__header__icon">
                      <VueFeather
                        type="mail"
                        size="16"
                        stroke-width="2"
                        style="display: block"
                      ></VueFeather>
                    </div>
                    <div class="review__header__title">Catatan Pemeriksaan</div>
                    <div class="review__header__close ml-auto">
                      <button class="button" variant="icon" size="sm">
                        <VueFeather
                          type="x"
                          size="16"
                          stroke-width="2"
                          style="display: block"
                        ></VueFeather>
                      </button>
                    </div>
                  </div>
                  <div
                    class="review__body"
                    style="overflow-y: auto; max-height: calc(100vh - 370px)"
                  >
                    <div
                      style="margin-bottom: 20px"
                      v-if="form.reviews && form.reviews.length > 0"
                    >
                      <div
                        v-for="(item, reviewIndex) in form.reviews"
                        :key="reviewIndex"
                        class="review-item d-block"
                      >
                        <div class="d-flex">
                          <div class="review-item__number">
                            {{ reviewIndex + 1 }}.
                          </div>
                          <div class="review-item__note">
                            <span class="review-item__field">
                              {{
                                item.field
                                  ? "#" +
                                    flatReviewFields.find(
                                      (x) => x.id == item.field
                                    ).label +
                                    " : "
                                  : ""
                              }}
                            </span>
                            {{ item.note }}
                          </div>
                        </div>
                        <div
                          class="d-flex align-items-center review-item__info pt-1"
                          style="padding-left: 19px"
                        >
                          <div
                            class="text-10 text-500 mr-2"
                            style="line-height: 1"
                            v-if="item.created_at"
                          >
                            {{ item.created_at | formatDate }}
                          </div>
                          <div
                            class="text-10 text-500 mr-2"
                            style="line-height: 1"
                            v-else
                          >
                            {{ msKeg.created_at | formatDate }}
                          </div>
                          <div class="ml-auto">
                            <b-button
                              class="button button--action button--action--delete"
                              style="
                                height: 20px;
                                width: 20px !important;
                                min-width: 20px !important;
                              "
                              v-b-tooltip.hover
                              title="Periksa"
                              @click="form.reviews.splice(reviewIndex, 1)"
                            >
                              <VueFeather type="x" size="12"></VueFeather>
                            </b-button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="history-review" v-if="msKeg">
                      <div
                        class="text-bold text-primary"
                        style="margin: 5px 11px"
                      >
                        History Pemeriksaan:
                      </div>
                      <div
                        v-if="reviewHistories.length == 0"
                        class=""
                        style="margin-top: -5px; margin-left: 11px"
                      >
                        Belum history yang tersedia
                      </div>
                      <div v-else class="mt-1">
                        <div
                          v-for="(review, reviewIndex) in reviewHistories"
                          :key="reviewIndex"
                          class="review-item d-block"
                        >
                          <div class="d-flex">
                            <div class="review-item__number">
                              {{ reviewIndex + 1 }}.
                            </div>
                            <div class="review-item__note">
                              <span class="review-item__field">
                                {{
                                  review.field ? "#" + review.field + " : " : ""
                                }}
                              </span>
                              {{ review.note }}
                            </div>
                          </div>
                          <div
                            class="d-flex align-items-center review-item__info pt-1"
                            style="padding-left: 19px"
                            v-if="review.created_at"
                          >
                            <div
                              class="text-10 text-500 mr-2"
                              style="line-height: 1"
                            >
                              {{ review.created_at | formatDate }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="history-status"
                      v-if="msKeg && msKegHistories && msKegHistories.length > 0"
                    >
                      <div
                        class="text-bold text-primary"
                        style="margin: 5px 11px"
                      >
                        Histori Status:
                      </div>
                      <div class="mt-1" style="margin: 0px 11px">
                        <div
                          v-for="(history, historyIndex) in msKegHistories"
                          :key="historyIndex"
                          class="history-status__item"
                        >
                          <div class="d-flex align-items-center">
                            <div class="history-status__number">
                              {{ historyIndex + 1 }}.
                            </div>
                            <div
                              :class="
                                'history-status__badge history-status__badge--' +
                                statusFormatterStyle(history.status)
                              "
                            >
                              {{ statusFormatter(history.status) }}
                            </div>
                            <div
                              class="text-10 text-500 ml-auto"
                              v-if="history.created_at"
                              style="line-height: 1"
                            >
                              {{ history.created_at | formatDate }}
                            </div>
                          </div>
                          <div
                            class="history-status__info"
                            v-if="
                              history.created_by &&
                              history.created_by.organization &&
                              history.created_by.organization.name
                            "
                          >
                            <span>{{
                              history.created_by.organization.name
                            }}</span>
                          </div>
                          <div
                            class="history-status__rejection"
                            v-if="history.status == 'REJECTED' && history.rejection_note"
                          >
                            <strong>Catatan Penolakan:</strong>
                            {{ history.rejection_note }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="review__footer form form--sm mt-auto">
                    <Treeselect
                      placeholder="Pilih attribute agar cakupan review lebih jelas"
                      v-model="review.field"
                      :options="reviewFields"
                      :clearable="true"
                      class="small-container"
                      :loadOptions="loadOptions"
                    >
                    </Treeselect>
                    <b-form-textarea
                      class="mt-1 text-13"
                      rows="3"
                      v-model="review.note"
                      placeholder="Tuliskan secara jelas definisi konsep dan batasannya"
                    >
                    </b-form-textarea>
                    <div class="d-flex justify-content-end mt-2">
                      <button
                        class="button"
                        variant="primary"
                        size="sm"
                        @click="
                          () => {
                            form.reviews.push({
                              field: review.field,
                              note: review.note,
                              created_at: now,
                            });
                            this.review = {
                              field: null,
                              note: null,
                            };
                          }
                        "
                      >
                        <VueFeather
                          type="plus"
                          size="14"
                          stroke-width="2"
                        ></VueFeather>
                        &nbsp; Tambah Catatan
                      </button>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab style="margin-right: -15px; margin-left: -15px">
            <div class="table-wrapper">
              <b-table
                class="table--light"
                show-empty
                :items="msVar.items"
                :fields="msVar.fields"
              >
                <template #cell(no)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(created_at)="data">
                  {{ data.value | formatDate }}
                </template>
                <template #cell(created_by)="data">
                  {{
                    data.item.requester_details
                      ? data.item.requester_details.name
                      : data.item.requested_by
                  }}
                </template>
                <template #cell(status)="data">
                  <div
                    :class="
                      'status status--' + statusFormatterStyle(data.value)
                    "
                  >
                    {{ statusFormatter(data.value) }}
                  </div>
                </template>
                <template #cell(aksi)="data">
                  <div class="d-flex justify-content-center">
                    <b-link
                      class="button button--action button--action--edit"
                      :to="'/metadata/pemeriksaan/variabel/' + data.item.id"
                      :disabled="
                        data.item.status == 'DRAFT' ||
                        data.item.status == 'CORRECTION_REQUIRED'
                      "
                    >
                      <VueFeather type="edit-3" size="14"></VueFeather>
                    </b-link>
                  </div>
                </template>
                <template #empty>
                  <div class="table__empty">
                    <div v-if="msVar.isLoading">
                      <VueFeather
                        type="loader"
                        animation="spin"
                        size="18"
                      ></VueFeather>
                      &nbsp; Memuat data
                    </div>
                    <div v-else>
                      <VueFeather type="alert-circle" size="18"></VueFeather>
                      &nbsp; Tidak ada data yang tersedia
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </b-tab>
          <b-tab style="margin-right: -15px; margin-left: -15px">
            <div class="table-wrapper">
              <b-table
                class="table--light"
                show-empty
                :items="msInd.items"
                :fields="msInd.fields"
              >
                <template #cell(no)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(created_at)="data">
                  {{ data.value | formatDate }}
                </template>
                <template #cell(created_by)="data">
                  {{
                    data.item.requester_details
                      ? data.item.requester_details.name
                      : data.item.requested_by
                  }}
                </template>
                <template #cell(status)="data">
                  <div
                    :class="
                      'status status--' + statusFormatterStyle(data.value)
                    "
                  >
                    {{ statusFormatter(data.value) }}
                  </div>
                </template>
                <template #cell(aksi)="data">
                  <div class="d-flex justify-content-center">
                    <b-link
                      class="button button--action button--action--edit"
                      :to="'/metadata/pemeriksaan/indikator/' + data.item.id"
                      :disabled="
                        data.item.status == 'DRAFT' ||
                        data.item.status == 'CORRECTION_REQUIRED'
                      "
                    >
                      <VueFeather type="edit-3" size="14"></VueFeather>
                    </b-link>
                  </div>
                </template>
                <template #empty>
                  <div class="table__empty">
                    <div v-if="msInd.isLoading">
                      <VueFeather
                        type="loader"
                        animation="spin"
                        size="18"
                      ></VueFeather>
                      &nbsp; Memuat data
                    </div>
                    <div v-else>
                      <VueFeather type="alert-circle" size="18"></VueFeather>
                      &nbsp; Tidak ada data yang tersedia
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <b-modal
      hide-header
      hide-footer
      id="modal-error"
      size="sm"
      content-class="modal--error text-center mt-5"
      dialog-class="d-flex justify-content-center"
    >
      <div>
        <div class="text-center py-5 px-2" style="color: red">
          <div class="mb-3 d-flex justify-content-center align-item-center">
            <div
              class="border mx-4"
              style="border-color: #f48fb1 !important; width: 40%"
            >
              <div
                style="
                  position: relative;
                  background-color: #fce4ec;
                  height: 20px;
                  border-color: #f48fb1 !important;
                "
                class="border-bottom mb-2"
              >
                <div style="position: absolute; top: -10px; right: -10px">
                  <VueFeather
                    type="x-circle"
                    size="20"
                    stroke-width="1.5"
                    fill="#FCE4EC"
                  ></VueFeather>
                </div>
              </div>
              <div class="px-3 py-2" style="">
                <b-skeleton
                  animation
                  width="85%"
                  height="10px"
                  style="
                    background-color: #fff1f6;
                    border: 1px solid #f8bbd0;
                    margin-bottom: 10px;
                  "
                ></b-skeleton>
                <b-skeleton animation width="55%" height="10px"></b-skeleton>
                <b-skeleton animation width="70%" height="10px"></b-skeleton>
                <b-skeleton animation width="100%" height="10px"></b-skeleton>
              </div>
            </div>
          </div>
          <div style="font-weight: 600; font-size: 17px; color: red">
            {{ modal.error.title }}
          </div>
          <div style=" font-weight: 500; font-size: 13px; color: #616161; word-break: break-word;" v-html="modal.error.description"> 
          
          </div>
          <div class="mt-3">
            <b-button
              class="i-button"
              style="
                color: white !important;
                background-color: #2e2e2e !important;
                padding: 3px 10px;
                border-radius: 3px !important;
                font-weight: 600;
              "
              v-on:click="
                () => {
                  $bvModal.hide('modal-error');
                }
              "
              >OK</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      hide-header
      hide-footer
      size="sm"
      id="modal-loading"
      content-class="modal modal--confirmation text-center p-2"
      centered
      dialog-class="d-flex justify-content-center"
    >
      <div class="text-center px-3 py-4">
        <img src="@/assets/img/loader.gif" width="100" height="100" />
        <div style="font-weight: 600; font-size: 16px; color: #01ad85">
          Mohon tunggu sebentar
        </div>
        <div style="font-weight: 500; font-size: 13px; color: #0a4e5c">
          Proses pengecekan Rekomendasi sedang berlangsung
        </div>
      </div>
    </b-modal>
    <b-modal
      hide-header
      hide-footer
      id="modal-saving"
      size="sm"
      content-class="modal modal--error text-center p-2"
      centered
      dialog-class="d-flex justify-content-center"
    >
      <div v-if="saveState == 'SAVING'">
        <div class="text-center py-3">
          <img src="@/assets/img/loader.gif" width="100" height="100" />
          <div style="font-weight: 600; font-size: 16px; color: #01ad85">
            Mohon tunggu sebentar
          </div>
          <div style="font-weight: 500; font-size: 13px; color: #0a4e5c">
            Proses menyimpan sedang berlangsung
          </div>
        </div>
      </div>
      <div v-if="saveState == 'SUCCESS'">
        <div class="text-center py-3">
          <img src="@/assets/img/success.gif" width="100" height="100" />
          <div style="font-weight: 600; font-size: 16px; color: #01ad85">
            Berhasil menyimpan
          </div>
          <div style="font-weight: 500; font-size: 13px; color: #0a4e5c">
            Anda akan di <i>redirect</i> ke halaman Daftar Pelaporan dalam
            beberapa detik
          </div>
        </div>
      </div>
      <div v-if="saveState == 'ERROR'">
        <div class="text-center py-3" style="color: red">
          <div>
            <VueFeather type="x-circle" size="50" stroke-width="1"></VueFeather>
          </div>
          <div style="font-weight: 600; font-size: 17px; color: red">Error</div>
          <div
            style="
              font-weight: 600;
              font-size: 13px;
              color: #0a4e5c;
              font-family: 'Open Sans';
            "
          >
            {{ saveError }}
          </div>
          <div class="mt-2">
            <b-button
              style="
                background-color: #2e2e2e !important;
                padding: 3px 10px;
                border-radius: 3px !important;
                font-weight: 600;
              "
              v-on:click="
                () => {
                  $bvModal.hide('modal-saving');
                }
              "
              >Kembali</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      hide-header
      hide-footer
      size="md"
      id="modal-approval"
      modal-class="modal modal--warning"
    >
      <ValidationObserver ref="saveSubmissionObserver" v-slot="{ validate }">
        <div class="modal__header border-bottom-0">
          <div class="modal__header__icon">
            <VueFeather type="send" size="22" stroke-width="2"></VueFeather>
          </div>
          <div class="modal__header__title">
            <div class="modal__header__title__name">Simpan Pemeriksaan</div>
            <div
              class="modal__header__title__description"
              style="font-weight: 500; letter-spacing: 0px"
            >
              Pastikan pemeriksaan sudah sesuai sebelum mengirim data ke server
            </div>
          </div>
          <div class="modal__header__close">
            <button
              class="button button--action button--outlined"
              @click="$bvModal.hide('modal-approval')"
            >
              <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
            </button>
          </div>
        </div>
        <div class="modal__body">
          <div class="form text-medium" style="border-radius: 4px">
            <b-form-group label="Status Usulan">
              <Treeselect
                :clearable="false"
                v-model="form.status"
                :options="options.status.filter((x) => x.id != 'REVISED')"
                :disable-branch-nodes="true"
                :loadOptions="loadOptions"
                class="valid"
              >
              </Treeselect>
            </b-form-group>

            <ValidationProvider
              immediate
              name="Jenis penolakan"
              rules="required"
              v-slot="{ errors }"
              v-if="form.status == 'REJECTED'"
            >
              <b-form-group label="Jenis penolakan">
                <Treeselect
                  :clearable="false"
                  placeholder="Pilih jenis alasan penolakan"
                  v-model="rejectionNote.type"
                  :class="
                    errors[0] ? 'invalid' : rejectionNote.type ? 'valid' : null
                  "
                  :options="options.rejected_status_type"
                  :loadOptions="loadOptions"
                />

                <b-form-invalid-feedback :state="false">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider
              immediate
              name="Catatan"
              v-if="rejectionNote.type == 'OTHER' && form.status == 'REJECTED'"
              rules="required"
              v-slot="{ errors }"
            >
              <b-form-group label="Catatan">
                <b-form-textarea
                  rows="3"
                  v-model="rejectionNote.note"
                  placeholder="Tuliskan secara jelas deskripsi ukuran"
                  :state="errors[0] ? false : rejectionNote.note ? true : null"
                >
                </b-form-textarea>
                <b-form-invalid-feedback :state="false">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </div>
        </div>
        <div class="modal__footer">
          <div class="d-flex ml-auto mx-1">
            <button
              type="button"
              class="button"
              variant="outlined"
              @click="$bvModal.hide('modal-approval')"
            >
              Batal
            </button>
            <button
              type="button"
              class="button ml-2"
              variant="warning"
              @click="
                () => {
                  validate().then((result) => {
                    if (result) {
                      sendData();
                    }
                  });
                }
              "
            >
              Kirim
            </button>
          </div>
        </div>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "@/assets/scss/main.scss";
import Treeselect from "@riophae/vue-treeselect";
import VueFeather from "vue-feather";
import * as role from "../SdiRole";

// import BDatePickerWithValidation from "@/components/inputs/BDatePicker2WithValidation";
import moment from "moment";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import rekomendasiService from "../../../services/RekomendasiService";
import MsService from "../../../services/MsService";
import SdsService from "../../../services/SdsService";
import WilayahService from "../../../services/WilayahService";
import store from "../../../store";
import "vue-select/dist/vue-select.css";
export default {
  components: {
    VueFeather,
    Treeselect,
    ValidationObserver,
    ValidationProvider,
    // BDatePickerWithValidation
  },
  data: () => ({
    route: null,
    baseId: null,
    updatedId: null,
    user: null,
    userRoles: [],
    isLoading: false,
    saveState: "SUCCESS",
    saveError: null,
    rejectionNote: {
      type: null,
      note: null,
    },

    tab: {
      index: 0,
      items: [
        {
          name: "Metadata Statistik Kegiatan",
          count: null,
        },
        {
          name: "Metadata Statistik Variabel",
          count: 0,
        },
        {
          name: "Metadata Statistik Indikator",
          count: 0,
        },
      ],
    },
    inputMode: 0,
    rekomendasi: null,
    msKeg: null,
    msVar: {
      isLoading: false,
      filter: null,
      filtered_items: [],
      items: [],
      fields: [
        {
          key: "no",
          label: "No.",
          tdClass: "text-center",
          thStyle: { width: "5px" },
        },
        {
          key: "data.nama",
          label: "Nama Variabel",
          thClass: "text-left w-300",
        },

        {
          key: "produsen_data_name",
          label: "Produsen Data",
          thClass: "text-left w-150",
          tdClass: "text-left",
        },
        {
          key: "created_by",
          label: "Pelapor",
          thClass: "text-left w-150",
          tdClass: "text-left",
        },
        {
          key: "created_at",
          label: "Tanggal Diajukan",
          thClass: "text-left w-150",
          tdClass: "text-left",
        },
        {
          key: "status",
          label: "Status",
          thClass: "text-center w-150",
          tdClass: "text-center text-nowrap",
        },
        {
          key: "aksi",
          label: "Periksa",
          thClass: "text-center w-90",
          tdClass: "text-center",
        },
      ],
    },
    msInd: {
      isLoading: false,
      filter: null,
      filtered_items: [],
      items: [],
      fields: [
        {
          key: "no",
          label: "No.",
          tdClass: "text-center",
          thStyle: { width: "5px" },
        },
        {
          key: "data.nama",
          label: "Nama Variabel",
          thClass: "text-left w-300",
        },

        {
          key: "produsen_data_name",
          label: "Produsen Data",
          thClass: "text-left w-150",
          tdClass: "text-left",
        },
        {
          key: "created_by",
          label: "Pelapor",
          thClass: "text-left w-150",
          tdClass: "text-left",
        },
        {
          key: "created_at",
          label: "Tanggal Diajukan",
          thClass: "text-left w-150",
          tdClass: "text-left",
        },
        {
          key: "status",
          label: "Status",
          thClass: "text-center w-150",
          tdClass: "text-center",
        },
        {
          key: "aksi",
          label: "Periksa",
          thClass: "text-center w-90",
          tdClass: "text-center",
        },
      ],
    },
    formExt: {
      getRecommendation: false,
      produsenData: null,
      wilayah: null,
    },
    review: {
      field: null,
      note: null,
    },
    reviewFields: [
      {
        id: "judul-kegiatan",
        label: "Judul Kegiatan",
      },
      {
        id: "tahun",
        label: "Tahun",
      },
      {
        id: "cara-pengumpulan-data",
        label: "Cara Pengumpulan Data",
      },
      {
        id: "sektor-kegiatan",
        label: "Sektor Kegiatan",
      },
      {
        id: "jenis-kegiatan-statistik",
        label: "Jenis Kegiatan Statistik ",
      },
      {
        id: "blok-I",
        label: "Blok I",
        children: [
          {
            id: "blok-I-instansi-penyelenggara",
            label: "1.1. Instansi Penyelenggara",
          },
          {
            id: "blok-I-alamat-lengkap-instansi-penyelenggara",
            label: "1.2. Alamat Lengkap Instansi Penyelenggara",
          },
        ],
      },
      {
        id: "blok-II",
        label: "Blok II",
        children: [
          {
            id: "blok-II-unit-eselon-penanggung-jawab",
            label: "2.1. Unit Eselon Penanggung Jawab",
          },
          {
            id: "blok-II-penanggung-jawab-teknis",
            label: "2.2. Penanggung Jawab Teknis",
          },
        ],
      },
      {
        id: "blok-III",
        label: "Blok III",
        children: [
          {
            id: "blok-III-latar-belakang-kegiatan",
            label: "3.1. Latar Belakang Kegiatan",
          },
          {
            id: "blok-III-tujuan-kegiatan",
            label: "3.2. Tujuan Kegiatan",
          },
          {
            id: "blok-III-rencana-jadwal-kegiatan",
            label: "3.3. Rencana Jadwal Kegiatan",
          },
          {
            id: "blok-III-variabel-yang-dikumpulkan",
            label: "3.4. Variabel (Karakteristik) yang Dikumpulkan",
          },
        ],
      },
      {
        id: "blok-IV",
        label: "Blok IV",
        children: [
          {
            id: "blok-IV-kegiatan-ini-dilakukan-berulang-atau-hanya-sekali",
            label: "4.1. Kegiatan ini Dilakukan Berulang atau Hanya Sekali",
          },
          {
            id: "blok-IV-frekuensi-penyelenggaraan",
            label: "4.2. Frekuensi Penyelenggaraan",
          },
          {
            id: "blok-IV-tipe-pengumpulan-data",
            label: "4.3. Tipe Pengumpulan Data",
          },
          {
            id: "blok-IV-cakupan-wilayah-pengumpulan-data",
            label: "4.4. Cakupan Wilayah Pengumpulan Data",
          },
          {
            id: "blok-IV-wilayah-kegiatan",
            label: "4.5. Wilayah Kegiatan",
          },
          {
            id: "blok-IV-metode-pengumpulan-data",
            label: "4.6. Metode Pengumpulan Data",
          },
          {
            id: "blok-IV-sarana-pengumpulan-data",
            label: "4.7 Sarana Pengumpulan Data",
          },
          {
            id: "blok-IV-unit-pengumpulan-data",
            label: "4.8. Unit Pengumpulan Data",
          },
        ],
      },
      {
        id: "blok-V",
        label: "Blok V",
        children: [
          {
            id: "blok-V-jenis-rancangan-sampel",
            label: "5.1. Jenis Rancangan Sampel",
          },
          {
            id: "blok-V-metode-pemilihan-sampel-tahap=terakhir",
            label: "5.2. Metode Pemilihan Sampel Tahap Terakhir",
          },
          {
            id: "blok-V-metode-yang-digunakan",
            label: "5.3. Metode yang Digunakan",
          },
          {
            id: "blok-V-kerangka-sampel-tahap-terakhir",
            label: "5.4. Kerangka Sampel Tahap Terakhir",
          },
          {
            id: "blok-V-fraksi-sampel-keseluruhan",
            label: "5.5. Fraksi Sampel Keseluruhan",
          },
          {
            id: "blok-V-nilai-perkiraan-sampling-error-variabel-utama",
            label: "5.6. Nilai Perkiraan Sampling Error Variabel Utama",
          },
          {
            id: "blok-V-unit-sampel",
            label: "5.7. Unit Sampel",
          },
          {
            id: "blok-V-unit-observasi",
            label: "5.8. Unit Observasi",
          },
        ],
      },
      {
        id: "blok-VI",
        label: "Blok VI",
        children: [
          {
            id: "blok-VI-apakah-melakukan-uji-coba",
            label: "6.1. Apakah Melakukan Uji Coba (Pilot Survey)",
          },
          {
            id: "blok-VI-metode-pemeriksaan-kualitas-pengumpulan-data",
            label: "6.2. Metode Pemeriksaan Kualitas Pengumpulan Data",
          },
          {
            id: "blok-VI-apakah-melakukan-penyesuaian-non-respon",
            label: "6.3. Apakah Melakukan Penyesuaian Nonrespon",
          },
          {
            id: "blok-VI-petugas-pengumpulan-data",
            label: "6.4. Petugas Pengumpulan Data",
          },
          {
            id: "blok-VI-persyaratan-pendidikan-petugas",
            label:
              "6.5. Persyaratan Pendidikan Terendah Petugas Pengumpulan Data",
          },
          {
            id: "blok-VI-jumlah-petugas",
            label: "6.6. Jumlah Petugas",
          },
          {
            id: "blok-VI-pelatihan-petugas",
            label: "6.7. Apakah Melakukan Pelatihan Petugas",
          },
        ],
      },
      {
        id: "blok-VII",
        label: "Blok VII",
        children: [
          {
            id: "blok-VII-tahapan-pengolahan-data",
            label: "7.1. Tahapan Pengolahan Data",
          },
          {
            id: "blok-VII-metode-analisis",
            label: "7.2. Metode Analisis",
          },
          {
            id: "blok-VII-unit-analisis",
            label: "7.3. Unit Analisis",
          },
          {
            id: "blok-VII-tingkat-penyajian-hasil-analisis",
            label: "7.4. Tingkat Penyajian Hasil Analisis",
          },
        ],
      },
      {
        id: "blok-VIII",
        label: "Blok VIII",
        children: [
          {
            id: "blok-VIII-produk-tersedia-untuk-umum",
            label: "8.1. Produk Kegiatan yang Tersedia untuk Umum",
          },
          {
            id: "blok-VIII-judul-dan-rencana-rilis-produk-kegiatan",
            label: "8.2. Judul dan Rencana Rilis Produk Kegiatan",
          },
        ],
      },
    ],
    flatReviewFields: [
      {
        id: "judul-kegiatan",
        label: "Judul Kegiatan",
      },
      {
        id: "tahun",
        label: "Tahun",
      },
      {
        id: "cara-pengumpulan-data",
        label: "Cara Pengumpulan Data",
      },
      {
        id: "sektor-kegiatan",
        label: "Sektor Kegiatan",
      },
      {
        id: "jenis-kegiatan-statistik",
        label: "Jenis Kegiatan Statistik ",
      },
      {
        id: "blok-I",
        label: "Blok I",
      },
      {
        id: "blok-II",
        label: "Blok II",
      },
      {
        id: "blok-III",
        label: "Blok III",
      },
      {
        id: "blok-IV",
        label: "Blok IV",
      },
      {
        id: "blok-V",
        label: "Blok V",
      },
      {
        id: "blok-VI",
        label: "Blok VI",
      },
      {
        id: "blok-VII",
        label: "Blok VII",
      },
      {
        id: "blok-VIII",
        label: "Blok VIII",
      },
      {
        id: "blok-I-instansi-penyelenggara",
        label: "1.1. Instansi Penyelenggara",
      },
      {
        id: "blok-I-alamat-lengkap-instansi-penyelenggara",
        label: "1.2. Alamat Lengkap Instansi Penyelenggara",
      },
      {
        id: "blok-II-unit-eselon-penanggung-jawab",
        label: "2.1. Unit Eselon Penanggung Jawab",
      },
      {
        id: "blok-II-penanggung-jawab-teknis",
        label: "2.2. Penanggung Jawab Teknis",
      },
      {
        id: "blok-III-latar-belakang-kegiatan",
        label: "3.1. Latar Belakang Kegiatan",
      },
      {
        id: "blok-III-tujuan-kegiatan",
        label: "3.2. Tujuan Kegiatan",
      },
      {
        id: "blok-III-rencana-jadwal-kegiatan",
        label: "3.3. Rencana Jadwal Kegiatan",
      },
      {
        id: "blok-III-variabel-yang-dikumpulkan",
        label: "3.4. Variabel (Karakteristik) yang Dikumpulkan",
      },
      {
        id: "blok-IV-kegiatan-ini-dilakukan-berulang-atau-hanya-sekali",
        label: "4.1. Kegiatan ini Dilakukan Berulang atau Hanya Sekali",
      },
      {
        id: "blok-IV-frekuensi-penyelenggaraan",
        label: "4.2. Frekuensi Penyelenggaraan",
      },
      {
        id: "blok-IV-tipe-pengumpulan-data",
        label: "4.3. Tipe Pengumpulan Data",
      },
      {
        id: "blok-IV-cakupan-wilayah-pengumpulan-data",
        label: "4.4. Cakupan Wilayah Pengumpulan Data",
      },
      {
        id: "blok-IV-wilayah-kegiatan",
        label: "4.5. Wilayah Kegiatan",
      },
      {
        id: "blok-IV-metode-pengumpulan-data",
        label: "4.6. Metode Pengumpulan Data",
      },
      {
        id: "blok-IV-sarana-pengumpulan-data",
        label: "4.7 Sarana Pengumpulan Data",
      },
      {
        id: "blok-IV-unit-pengumpulan-data",
        label: "4.8. Unit Pengumpulan Data",
      },
      {
        id: "blok-V-jenis-rancangan-sampel",
        label: "5.1. Jenis Rancangan Sampel",
      },
      {
        id: "blok-V-metode-pemilihan-sampel-tahap=terakhir",
        label: "5.2. Metode Pemilihan Sampel Tahap Terakhir",
      },
      {
        id: "blok-V-metode-yang-digunakan",
        label: "5.3. Metode yang Digunakan",
      },
      {
        id: "blok-V-kerangka-sampel-tahap-terakhir",
        label: "5.4. Kerangka Sampel Tahap Terakhir",
      },
      {
        id: "blok-V-fraksi-sampel-keseluruhan",
        label: "5.5. Fraksi Sampel Keseluruhan",
      },
      {
        id: "blok-V-nilai-perkiraan-sampling-error-variabel-utama",
        label: "5.6. Nilai Perkiraan Sampling Error Variabel Utama",
      },
      {
        id: "blok-V-unit-sampel",
        label: "5.7. Unit Sampel",
      },
      {
        id: "blok-V-unit-observasi",
        label: "5.8. Unit Observasi",
      },
      {
        id: "blok-VI-apakah-melakukan-uji-coba",
        label: "6.1. Apakah Melakukan Uji Coba (Pilot Survey)",
      },
      {
        id: "blok-VI-metode-pemeriksaan-kualitas-pengumpulan-data",
        label: "6.2. Metode Pemeriksaan Kualitas Pengumpulan Data",
      },
      {
        id: "blok-VI-apakah-melakukan-penyesuaian-non-respon",
        label: "6.3. Apakah Melakukan Penyesuaian Nonrespon",
      },
      {
        id: "blok-VI-petugas-pengumpulan-data",
        label: "6.4. Petugas Pengumpulan Data",
      },
      {
        id: "blok-VI-persyaratan-pendidikan-petugas",
        label: "6.5. Persyaratan Pendidikan Terendah Petugas Pengumpulan Data",
      },
      {
        id: "blok-VI-jumlah-petugas",
        label: "6.6. Jumlah Petugas",
      },
      {
        id: "blok-VI-pelatihan-petugas",
        label: "6.7. Apakah Melakukan Pelatihan Petugas",
      },
      {
        id: "blok-VII-tahapan-pengolahan-data",
        label: "7.1. Tahapan Pengolahan Data",
      },
      {
        id: "blok-VII-metode-analisis",
        label: "7.2. Metode Analisis",
      },
      {
        id: "blok-VII-unit-analisis",
        label: "7.3. Unit Analisis",
      },
      {
        id: "blok-VII-tingkat-penyajian-hasil-analisis",
        label: "7.4. Tingkat Penyajian Hasil Analisis",
      },
      {
        id: "blok-VIII-produk-tersedia-untuk-umum",
        label: "8.1. Produk Kegiatan yang Tersedia untuk Umum",
      },
      {
        id: "blok-VIII-judul-dan-rencana-rilis-produk-kegiatan",
        label: "8.2. Judul dan Rencana Rilis Produk Kegiatan",
      },
    ],
    form: {
      base_id: null,
      submission_period: new Date().getFullYear(),
      data: null,
      reviews: null,
      status: "DRAFT",
      rejection_note: null,
      submitter: null,
      produsen_data: null,
      walidata_pusat: null,
      version: "v2",
      changes: null,

      // reviews: [
      //   {
      //     created_at: null,
      //     field: null,
      //     note: null
      //   }
      // ],
      // submitter: {
      //   name: null,
      //   username: null,
      //   email: null,
      //   organization: {
      //     id: 0,
      //     name: null,
      //     address: null,
      //     province: {
      //       code: null,
      //       name: null
      //     },
      //     city: {
      //       code: null,
      //       name: null
      //     }
      //   }
      // },
      // rejection_note: {
      //   note: null,
      //   type: "IMPROPERLY_REQUEST"
      // },
      // produsen_data: {
      //   id: 0,
      //   name: null,
      //   province_code: null,
      //   city_code: null
      // },
      // walidata_pusat: {
      //   id: 0,
      //   name: null
      // },
    },
    data: {
      judul_kegiatan: null,
      tahun: null,
      jenis_statistik: null,
      cara_pengumpulan_data: null,
      sektor_kegiatan: null,
      identitas_rekomendasi: null,
      blok_i: {
        instansi_penyelanggara: null,
        alamat_instansi_penyelenggara: {
          alamat: null,
          telepon: null,
          email: null,
          faksimile: null,
        },
      },
      blok_ii: {
        unit_penanggung_jawab: {
          eselon1: null,
          eselon2: null,
        },
        penanggung_jawab_teknis: {
          nama: null,
          jabatan: null,
          alamat: null,
          telepon: null,
          email: null,
          faksimile: null,
        },
      },
      blok_iii: {
        latar_belakang_kegiatan: null,
        tujuan_kegiatan: null,
        rencana_jadwal_kegiatan: {
          perencanaan_kegiatan: [
            {
              awal: null,
              akhir: null,
            },
          ],
          desain: [
            {
              awal: null,
              akhir: null,
            },
          ],
          pengumpulan_data: [
            {
              awal: null,
              akhir: null,
            },
          ],
          pengolahan_data: [
            {
              awal: null,
              akhir: null,
            },
          ],
          analisis: [
            {
              awal: null,
              akhir: null,
            },
          ],
          diseminasi_hasil: [
            {
              awal: null,
              akhir: null,
            },
          ],
          evaluasi: [
            {
              awal: null,
              akhir: null,
            },
          ],
        },
        variabel_yang_dikumpulkan: [
          {
            nama: null,
            konsep: null,
            definisi: null,
            referensi_waktu: null,
          },
        ],
      },
      blok_iv: {
        kegiatan_ini_dilakukan: null,
        frekuensi_penyelanggara: null,
        tipe_pengumpulan_data: null,
        cakupan_wilayah_pengumpulan_data: null,
        sebagian_cakupan_wilayah_pengumpulan_data: [],
        metode_pengumpulan_data: {
          wawancara: null,
          mengisi_kuesioner_sendiri: null,
          pengamatan: null,
          pengumpulan_data_sekunder: null,
          lainnya: null,
          metode_pengumpulan_lainnya: null,
        },
        sarana_pengumpulan_data: {
          papi: null,
          capi: null,
          cati: null,
          cawi: null,
          mail: null,
          lainnya: null,
          sarana_pengumpulan_lainnya: null,
        },
        unit_pengumpulan_data: {
          individu: null,
          rumah_tangga: null,
          usaha_atau_perusahaan: null,
          lainnya: null,
          unit_pengumpulan_data_lainnya: null,
        },
      },
      blok_v: {
        jenis_rancangan_sampel: null,
        metode_pemilihan_sampel_tahap_terakhir: null,
        metode_yang_digunakan: null,
        kerangka_sampel_tahap_terakhir: null,
        fraksi_sampel_keseluruhan: null,
        nilai_perkiraan_sampling_error_variabel_utama: null,
        unit_sampel: null,
        unit_observasi: null,
      },
      blok_vi: {
        apakah_melakukan_uji_coba: null,
        metode_pemeriksaan_kualitas_pengumpulan_data: {
          kunjungan_kembali: null,
          supervisi: null,
          taskforce: null,
          lainnya: null,
          metode_pemeriksaan_kualitas_pengumpulan_data_lainnya: null,
        },
        apakah_melakukan_penyesuaian_nonrespon: null,
        petugas_pengumpulan_data: null,
        persyaratan_pendidikan_terendah_petugas_pengumpulan_data: null,
        jumlah_petugas_supervisor: 0,
        jumlah_petugas_enumerator: 0,
        apakah_melakukan_pelatihan_petugas: true,
      },
      blok_vii: {
        tahapan_pengolahan_data: {
          editing: null,
          coding: null,
          data_entry: null,
          validasi: null,
        },
        metode_analisis: null,
        unit_analsis: {
          individu: null,
          rumah_tangga: null,
          usaha_atau_perusahaan: null,
          lainnya: null,
          unit_analisis_lainnya: null,
        },
        tingkat_penyajian_hasil_analisis: {
          nasional: null,
          provinsi: null,
          kabupaten_atau_kota: null,
          kecamatan: null,
          lainnya: null,
          tingkat_penyajian_hasil_analisis_lainnya: null,
        },
      },
      blok_viii: {
        ketersediaan_produk_tercetak: null,
        ketersediaan_produk_digital: null,
        ketersediaan_produk_mikrodata: null,
        rencana_jadwal_rilis_produk_tercetak: [],
        rencana_jadwal_rilis_produk_digital: [],
        rencana_jadwal_rilis_produk_mikrodata: [],
      },
    },
    ques: {
      judul_kegiatan: null,
      tahun: new Date().getFullYear(),
      jenis_statistik: "STATISTIK_DASAR",
      cara_pengumpulan_data: null,
      sektor_kegiatan: null,
      identitas_rekomendasi: null,
      blok_i: {
        instansi_penyelanggara: null,
        blok_ialamat_instansi_penyelenggara: {
          alamat: null,
          telepon: null,
          email: null,
          faksimile: null,
        },
      },
      blok_ii: {
        unit_penanggung_jawab: {
          eselon1: null,
          eselon2: null,
        },
        penanggung_jawab_teknis: {
          nama: null,
          jabatan: null,
          alamat: null,
          telepon: null,
          email: null,
          faksimile: null,
        },
      },
      blok_iii: {
        latar_belakang_kegiatan: null,
        tujuan_kegiatan: null,
        rencana_jadwal_kegiatan: {
          perencanaan_kegiatan: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01",
            },
          ],
          desain: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01",
            },
          ],
          pengumpulan_data: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01",
            },
          ],
          pengolahan_data: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01",
            },
          ],
          analisis: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01",
            },
          ],
          diseminasi_hasil: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01",
            },
          ],
          evaluasi: [
            {
              awal: "2020-10-01",
              akhir: "2020-10-01",
            },
          ],
        },
        variabel_yang_dikumpulkan: [
          {
            nama: null,
            konsep: null,
            definisi: null,
            referensi_waktu: null,
          },
        ],
      },
      blok_iv: {
        kegiatan_ini_dilakukan: "HANYA_SEKALI",
        frekuensi_penyelanggara: "HARIAN",
        tipe_pengumpulan_data: "LONGITUDINAL_PANEL",
        cakupan_wilayah_pengumpulan_data: "SELURUH_WILAYAH_INDONESIA",
        sebagian_cakupan_wilayah_pengumpulan_data: [],
        metode_pengumpulan_data: {
          wawancara: null,
          mengisi_kuesioner_sendiri: null,
          pengamatan: null,
          pengumpulan_data_sekunder: null,
          lainnya: null,
          metode_pengumpulan_lainnya: null,
        },
        sarana_pengumpulan_data: {
          papi: null,
          capi: null,
          cati: null,
          cawi: true,
          mail: true,
          lainnya: true,
          sarana_pengumpulan_lainnya: null,
        },
        unit_pengumpulan_data: {
          individu: true,
          rumah_tangga: true,
          usaha_atau_perusahaan: true,
          lainnya: true,
          unit_pengumpulan_data_lainnya: null,
        },
      },
      blok_v: {
        jenis_rancangan_sampel: "SINGLE_STAGE_ATAU_PHASE",
        metode_pemilihan_sampel_tahap_terakhir: "SAMPEL_PROBABILITAS",
        metode_yangdigunakan: "SIMPLE_RANDOM_SAMPLING",
        kerangka_sampel_tahap_terakhir: "LIST_FRAME",
        fraksi_sampel_keseluruhan: null,
        nilai_perkiraan_sampling_error_variabel_utama: null,
        unit_sampel: null,
        unit_observasi: null,
      },
      blok_vi: {
        apakah_melakukan_uji_coba: true,
        metode_pemeriksaan_kualitas_pengumpulan_data: {
          kunjungan_kembali: true,
          supervisi: true,
          taskforce: true,
          lainnya: true,
          metode_pemeriksaan_kualitas_pengumpulan_data_lainnya: null,
        },
        apakah_melakukan_penyesuaian_nonrespon: true,
        petugas_pengumpulan_data: "STAF_INSTANSI_PENYELENGGARA",
        persyaratan_pendidikan_terendah_petugas_pengumpulan_data:
          "KURANG_DARI_ATAU_SAMA_DENGAN_SMP",
        jumlah_petugas_supervisor: 0,
        jumlah_petugas_enumerator: 0,
        apakah_melakukan_pelatihan_petugas: true,
      },
      blok_vii: {
        tahapan_pengolahan_data: {
          editing: true,
          coding: true,
          data_entry: true,
          validasi: true,
        },
        metode_analisis: "DESKRIPTIF",
        unit_analsis: {
          individu: true,
          rumah_tangga: true,
          usaha_atau_perusahaan: true,
          lainnya: true,
          unit_analisis_lainnya: null,
        },
        tingkat_penyajian_hasil_analisis: {
          nasional: true,
          provinsi: true,
          kabupaten_atau_kota: true,
          kecamatan: true,
          lainnya: true,
          tingkat_penyajian_hasil_analisis_lainnya: null,
        },
      },
      blok_viii: {
        ketersediaan_produk_tercetak: true,
        ketersediaan_produk_digital: true,
        ketersediaan_produk_mikrodata: true,
        rencana_jadwal_rilis_produk_tercetak: [],
        rencana_jadwal_rilis_produk_digital: [],
        rencana_jadwal_rilis_produk_mikrodata: [],
      },
    },
    options: {
      rejected_status_type: [
        { id: "IMPROPERLY_REQUEST", label: "Laporan Metadata tidak layak" },
        { id: "REQUESTED_BY_USER", label: "Diminta oleh pelapor" },
        { id: "OTHER", label: "Lainnya" },
      ],
      status: [
        { id: "DRAFT", label: "Draft" },
        { id: "SUBMITTED", label: "Submit" },
        { id: "UNDER_REVIEW", label: "Sedang Diperiksa" },
        { id: "REVISED", label: "Sudah Diperbaiki" },
        { id: "CORRECTION_REQUIRED", label: "Perlu Perbaikan" },
        { id: "REJECTED", label: "Ditolak" },
        { id: "APPROVED", label: "Disetujui" },
        // { id: "PUBLISHED", label: "Publis" }
      ],
      jenis_statistik: [
        {
          id: "STATISTIK_DASAR",
          label: "Statistik Dasar",
          description:
            "Statistik yang pemanfaatannya ditujukan untuk keperluan yang bersifat luas, baik pemerintah maupun masyarakat, yang memiliki ciri-ciri lintas sektoral, berskala nasional maupun regional, makro, dan yang penyelenggaraannya menjadi tanggung jawab BPS.",
          color: "primary",
        },
        {
          id: "STATISTIK_SEKTORAL",
          label: "Statistik Sektoral",
          description:
            "Statistik yang pemanfaatannya ditujukan untuk memenuhi kebutuhan instansi pemerintah tertentu dalam rangka penyelenggaraan tugas-tugas pemerintah dan tugas pembangunan yang merupakan tugas pokok instansi pemerintah yang bersangkutan. Meskipun program pelaksanaannya menjadi tanggung jawab instansi pemerintah terkait, dalam praktek pelaksanaan dapat bekerja sama dengan BPS.",
          color: "secondary",
        },
        {
          id: "STATISTIK_KHUSUS",
          label: "Statistik Khusus",
          description:
            " Statistik yang pemanfaatannya ditujukan untuk memenuhi kebutuhan intern dari suatu instansi/perusahaan swasta dalam rangka penyelenggaraan riset atau penelitian. Meskipun pelaksanaannya menjadi tanggung jawab instansi/perusahaan terkait, dalm praktek pelaksanaan dapat bekerja sama dengan BPS.",
          color: "tertiary",
        },
      ],
      cara_pengumpulan_data: [
        { id: "PENCACAHAN_LENGKAP", label: "Pencacahan Lengkap ", code: 1 },
        { id: "SURVEI", label: "Survei", code: 2 },
        {
          id: "KOMPILASI_PRODUK_ADMINISTRASI",
          label: "Kompilasi Produk Administrasi",
          code: 3,
        },
        {
          id: "CARA_LAIN_SESUAI_DENGAN_PERKEMBANGAN_TI",
          label: "Cara Lain Sesuai Dengan Perkembangan Ti",
          code: 4,
        },
      ],
      sektor_kegiatan: [
        {
          id: "PERTANIAN_DAN_PERIKANAN",
          label: "Pertanian Dan Perikanan",
          code: 1,
        },
        {
          id: "DEMOGRAFI_DAN_KEPENDUDUKAN",
          label: "Demografi Dan Kependudukan",
          code: 2,
        },
        { id: "PEMBANGUNAN", label: "Pembangunan", code: 3 },
        { id: "PROYEKSI_EKONOMI", label: "Proyeksi Ekonomi", code: 4 },
        {
          id: "PENDIDIKAN_DAN_PELATIHAN",
          label: "Pendidikan Dan Pelatihan",
          code: 5,
        },
        { id: "LINGKUNGAN", label: "Lingkungan", code: 6 },
        { id: "KEUANGAN", label: "Keuangan", code: 7 },
        { id: "GLOBALISASI", label: "Globalisasi", code: 8 },
        { id: "KESEHATAN", label: "Kesehatan", code: 9 },
        { id: "INDUSTRI_DAN_JASA", label: "Industri Dan Jasa", code: 10 },
        {
          id: "TEKNOLOGI_INFORMASI_DAN_KOMUNIKASI",
          label: "Teknologi Informasi Dan Komunikasi",
          code: 11,
        },
        {
          id: "PERDAGANGAN_INTERNASIONAL_DAN_NERACA_PERDAGANGAN",
          label: "Perdagangan Internasional Dan Neraca Perdagangan",
          code: 12,
        },
        { id: "KETENAGAKERJAAN", label: "Ketenagakerjaan", code: 13 },
        { id: "NERACA_NASIONAL", label: "Neraca Nasional", code: 14 },
        {
          id: "INDIKATOR_EKONOMI_BULANAN",
          label: "Indikator Ekonomi Bulanan",
          code: 15,
        },
        { id: "PRODUKTIVITAS", label: "Produktivitas", code: 16 },
        {
          id: "HARGA_DAN_PARITAS_DAYA_BELI",
          label: "Harga Dan Paritas Daya Beli",
          code: 17,
        },
        {
          id: "SEKTOR_PUBLIK_PERPAJAKAN_DAN_REGULASI_PASAR",
          label: "Sektor Publik Perpajakan Dan Regulasi Pasar",
          code: 18,
        },
        {
          id: "PERWILAYAHAN_DAN_PERKOTAAN",
          label: "Perwilayahan Dan Perkotaan",
          code: 19,
        },
        {
          id: "ILMU_PENGETAHUAN_DAN_HAK_PATEN",
          label: "Ilmu Pengetahuan Dan Hak Paten",
          code: 20,
        },
        {
          id: "PERLINDUNGAN_SOSIAL_DAN_KESEJAHTERAAN",
          label: "Perlindungan Sosial Dan Kesejahteraan",
          code: 21,
        },
        { id: "TRANSPORTASI;", label: "Transportasi;", code: 22 },
      ],
      kegiatan_ini_dilakukan: [
        { id: "HANYA_SEKALI", label: "Hanya Sekali", code: 1 },
        { id: "BERULANG", label: "Berulang", code: 2 },
      ],
      frekuensi_penyelanggara: [
        { id: "HARIAN", label: "Harian ", code: 1 },
        { id: "MINGGUAN", label: "Mingguan", code: 2 },
        { id: "BULANAN", label: "Bulanan", code: 3 },
        { id: "TRIWULANAN", label: "Triwulanan", code: 4 },
        { id: "EMPAT_BULANAN", label: "Empat Bulanan", code: 5 },
        { id: "SEMESTERAN", label: "Semesteran", code: 6 },
        { id: "TAHUNAN", label: "Tahunan", code: 7 },
        {
          id: "LEBIH_DARI_DUA_TAHUNAN",
          label: "Lebih Dari Dua Tahunan",
          code: 8,
        },
      ],
      tipe_pengumpulan_data: [
        { id: "LONGITUDINAL_PANEL", label: "Longitudinal Panel", code: 1 },
        {
          id: "LONGITUDINAL_CROSS_SECTIONAL",
          label: "Longitudinal Cross Sectional",
          code: 2,
        },
        { id: "CROSS_SECTIONAL", label: "Cross Sectional", code: 3 },
      ],
      cakupan_wilayah_pengumpulan_data: [
        {
          id: "SELURUH_WILAYAH_INDONESIA",
          label: "Seluruh Wilayah Indonesia",
          code: 1,
        },
        {
          id: "SEBAGIAN_WILAYAH_INDONESIA",
          label: "Sebagian Wilayah Indonesia",
          code: 2,
        },
      ],
      jenis_rancangan_sampel: [
        {
          id: "SINGLE_STAGE_ATAU_PHASE",
          label: "Single Stage Atau Phase",
          code: 1,
        },
        {
          id: "MULTI_STAGE_ATAU_PHASE",
          label: "Multi Stage Atau Phase",
          code: 2,
        },
      ],
      metode_pemilihan_sampel_tahap_terakhir: [
        { id: "SAMPEL_PROBABILITAS", label: "Sampel Probabilitas", code: 1 },
        {
          id: "SAMPEL_NONPROBABILITAS",
          label: "Sampel Nonprobabilitas",
          code: 2,
        },
      ],
      metode_sampel_probabilitas: [
        {
          id: "SIMPLE_RANDOM_SAMPLING",
          label: "Simple Random Sampling",
          code: 1,
        },
        {
          id: "SYSTEMATIC_RANDOM_SAMPLING",
          label: "Systematic Random Sampling",
          code: 2,
        },
        {
          id: "STRATIFIED_RANDOM_SAMPLING",
          label: "Stratified Random Sampling",
          code: 3,
        },
        { id: "CLUSTER_SAMPLING", label: "Cluster Sampling", code: 4 },
        {
          id: "PROBABILTY_PROPORTIONAL_TO_SIZE_SAMPLING",
          label: "Probabilty Proportional to Size Sampling",
          code: 5,
        },
      ],
      metode_sampel_nonprobabilitas: [
        { id: "QUOTA_SAMPLING", label: "Quota Sampling", code: 6 },
        { id: "ACCIDENTAL_SAMPLING", label: "Accidental Sampling", code: 7 },
        { id: "PURPOSIVE_SAMPLING", label: "Purposive Sampling", code: 8 },
        { id: "SNOWBALL_SAMPLING", label: "Snowball Sampling", code: 9 },
        { id: "SATURATION_SAMPLING", label: "Saturation Sampling", code: 10 },
      ],
      kerangka_sampel_tahap_terakhir: [
        { id: "LIST_FRAME", label: "List Frame", code: 1 },
        { id: "AREA_FRAME", label: "Area Frame", code: 2 },
      ],
      metode_pemeriksaan_kualitas_pengumpulan_data: [
        {
          id: "KUNJUNGAN_KEMBALI_ATAU_REVISIT",
          label: "Kunjungan Kembali Atau Revisit",
          code: 1,
        },
        { id: "SUPERVISI", label: "Supervisi", code: 2 },
        { id: "TASK_FORCE", label: "Task Force", code: 4 },
        { id: "LAINNYA", label: "Lainnya", code: 8 },
      ],
      petugas_pengumpulan_data: [
        {
          id: "STAF_INSTANSI_PENYELENGGARA",
          label: "Staf Instansi Penyelenggara",
          code: 1,
        },
        {
          id: "MITRA_ATAU_TENAGA_KONTRAK",
          label: "Mitra Atau Tenaga Kontrak",
          code: 2,
        },
        {
          id: "STAF_INSTANSI_PENYELENGGARA_DAN_MITRA_ATAU_TENAGA_KONTRAK",
          label: "Staf Instansi Penyelenggara Dan Mitra Atau Tenaga Kontrak",
          code: 3,
        },
      ],
      persyaratan_pendidikan_terendah_petugas_pengumpulan_data: [
        {
          id: "KURANG_DARI_ATAU_SAMA_DENGAN_SMP",
          label: "Kurang Dari Atau Sama Dengan Smp",
          code: 1,
        },
        { id: "SMA_ATAU_SMK", label: "Sma Atau Smk", code: 2 },
        {
          id: "DIPLOMA_I_ATAU_II_ATAU_III",
          label: "Diploma I Atau Ii Atau Iii",
          code: 3,
        },
        {
          id: "DIPLOMA_IV_ATAU_S1_ATAU_S2_ATAU_S3",
          label: "Diploma Iv Atau S1 Atau S2 Atau S3",
          code: 4,
        },
      ],
      metode_analisis: [
        { id: "DESKRIPTIF", label: "Deskriptif", code: 1 },
        { id: "INFERENSIA", label: "Inferensia", code: 2 },
        {
          id: "DESKRIPTIF_DAN_INFERENSIA",
          label: "Deskriptif Dan Inferensia",
          code: 3,
        },
      ],
      ya_tidak: [
        { id: true, label: "Ya", code: 1 },
        { id: false, label: "Tidak", code: 2 },
      ],
      city: [],
      wilayah: [
        {
          id: 1,
          code: 11,
          name: "ACEH",
          children: [],
        },
        {
          id: 2,
          code: 12,
          name: "SUMATERA UTARA",
          children: [],
        },
        {
          id: 3,
          code: 13,
          name: "SUMATERA BARAT",
          children: [],
        },
        {
          id: 4,
          code: 14,
          name: "RIAU",
          children: [],
        },
        {
          id: 5,
          code: 15,
          name: "JAMBI",
          children: [],
        },
        {
          id: 6,
          code: 16,
          name: "SUMATERA SELATAN",
          children: [],
        },
        {
          id: 7,
          code: 17,
          name: "BENGKULU",
          children: [],
        },
        {
          id: 8,
          code: 18,
          name: "LAMPUNG",
          children: [],
        },
        {
          id: 9,
          code: 19,
          name: "KEPULAUAN BANGKA BELITUNG",
          children: [],
        },
        {
          id: 10,
          code: 21,
          name: "KEPULAUAN RIAU",
          children: [],
        },
        {
          id: 11,
          code: 31,
          name: "DKI JAKARTA",
          children: [],
        },
        {
          id: 12,
          code: 32,
          name: "JAWA BARAT",
          children: [],
        },
        {
          id: 13,
          code: 33,
          name: "JAWA TENGAH",
          children: [],
        },
        {
          id: 14,
          code: 34,
          name: "DI YOGYAKARTA",
          children: [],
        },
        {
          id: 15,
          code: 35,
          name: "JAWA TIMUR",
          children: [],
        },
        {
          id: 16,
          code: 36,
          name: "BANTEN",
          children: [],
        },
        {
          id: 17,
          code: 51,
          name: "BALI",
          children: [],
        },
        {
          id: 18,
          code: 52,
          name: "NUSA TENGGARA BARAT",
          children: [],
        },
        {
          id: 19,
          code: 53,
          name: "NUSA TENGGARA TIMUR",
          children: [],
        },
        {
          id: 20,
          code: 61,
          name: "KALIMANTAN BARAT",
          children: [],
        },
        {
          id: 21,
          code: 62,
          name: "KALIMANTAN TENGAH",
          children: [],
        },
        {
          id: 22,
          code: 63,
          name: "KALIMANTAN SELATAN",
          children: [],
        },
        {
          id: 23,
          code: 64,
          name: "KALIMANTAN TIMUR",
          children: [],
        },
        {
          id: 24,
          code: 65,
          name: "KALIMANTAN UTARA",
          children: [],
        },
        {
          id: 25,
          code: 71,
          name: "SULAWESI UTARA",
          children: [],
        },
        {
          id: 26,
          code: 72,
          name: "SULAWESI TENGAH",
          children: [],
        },
        {
          id: 27,
          code: 73,
          name: "SULAWESI SELATAN",
          children: [],
        },
        {
          id: 28,
          code: 74,
          name: "SULAWESI TENGGARA",
          children: [],
        },
        {
          id: 29,
          code: 75,
          name: "GORONTALO",
          children: [],
        },
        {
          id: 30,
          code: 76,
          name: "SULAWESI BARAT",
          children: [],
        },
        {
          id: 31,
          code: 81,
          name: "MALUKU",
          children: [],
        },
        {
          id: 32,
          code: 82,
          name: "MALUKU UTARA",
          children: [],
        },
        {
          id: 33,
          code: 91,
          name: "PAPUA BARAT",
          children: [],
        },
        {
          id: 34,
          code: 94,
          name: "PAPUA",
          children: [],
        },
      ],
      userWilayah: [],
      produsen_data: [],
    },
    modal: {
      error: {
        title: null,
        description: null,
      },
    },
  }),
  async mounted() {
    this.route = this.$route.name;
    this.getUserInfo(store.getters["auth/user"]);
    this.setWilayah();
    let id = parseInt(this.$route.params.id);
    this.updatedId = id;
    this.isLoading = true;
    await this.getDetailMsKeg(id);
    this.isLoading = false;

    if (localStorage.msLastApproval) {
      let msLastApproval = JSON.parse(localStorage.msLastApproval);
      if (id == msLastApproval.ms_keg_id) {
        this.tab.index = parseInt(msLastApproval.tab_index);
      }
    }
  },
  computed: {
    now() {
      return moment().format("YYYY-MM-DD HH:mm:ss.SSS");
    },
    reviewHistories() {
      let msKeg = this.msKeg;
      let allReview = msKeg.ms_keg_histories
        .filter((x) => !x.active && x.reviews && x.reviews.length > 0)
        .map((x) => x.reviews)
        .flat();
      let currentReviewNotes = msKeg.reviews
        ? msKeg.reviews.map((x) => x.note)
        : [];

      let showedReviews = [];
      allReview.forEach((x) => {
        if (!currentReviewNotes.includes(x.note)) {
          showedReviews.push(x);
        }
      });
      return showedReviews;
    },
    /**
     * History perubahan STATUS dari MS-Keg, diurutkan dari yang terbaru.
     * Sumber: msKeg.ms_keg_histories (tiap item berisi status, created_at,
     * created_by, rejection_note, dll).
     * Item dengan active=true (status saat ini) tetap ditampilkan di atas
     * sebagai "Status Saat Ini", sedangkan sisanya adalah historis.
     */
    msKegHistories() {
      const msKeg = this.msKeg;
      if (!msKeg || !Array.isArray(msKeg.ms_keg_histories)) {
        return [];
      }
      // Sort dari yang terbaru ke yang terlama
      return [...msKeg.ms_keg_histories].sort((a, b) => {
        const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
        const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
        return tb - ta;
      });
    },
  },
  watch: {
    "formExt.wilayah"() {
      this.data.blok_iv.sebagian_cakupan_wilayah_pengumpulan_data =
        this.formExt.wilayah
          .map((item) => {
            return {
              //by selected one by one
              kode_provinsi: item.province_id,
              nama_provinsi: item.province_name,
              kode_kabupaten_kota: item.id,
              nama_kabupaten_kota: item.name,
            };
          })
          .sort(
            (x, y) =>
              parseInt(x.kode_kabupaten_kota) - parseInt(y.kode_kabupaten_kota)
          );
    },
  },
  methods: {
    getUserInfo(user) {
      this.user = {
        username: user.username,
        name: user.name,
        email: user.email,
        organization: {
          id: user.sdiOrganization.id,
          name: user.sdiOrganization.name,
          address: user.sdiOrganization.details.address,
          province: user.sdiOrganization.details.province,
          city: user.sdiOrganization.details.city,
        },
      };
      this.userRoles = user.role.slice(1, -1).split(", ");
      this.form.submitter = this.user;
      // this.form.walidata_pusat = user.sdiOrganization.details.walidata
    },
    async getDetailMsKeg(id) {
      await MsService.getMsKegById(id).then(
        (response) => {
          this.msKeg = response.data.result[0];
          let msKeg = response.data.result[0];

          this.msVar.items = msKeg.ms_var.sort(
            (a, b) =>
              new Date(b.created_at).getTime() -
              new Date(a.created_at).getTime()
          );
          this.tab.items[1].count = this.msVar.items.length;

          this.msInd.items = msKeg.ms_ind;
          this.tab.items[2].count = this.msInd.items.length;

          this.form = {
            id: msKeg.id || id,
            base_id: this.baseId ? this.baseId : null,
            submission_period: msKeg.submission_period || (msKeg.data ? msKeg.data.tahun : null),
            data: null,
            reviews: msKeg.reviews ? msKeg.reviews : [],
            status: msKeg.status,
            rejection_note: msKeg.rejection_note,
            submitter: this.user,
            produsen_data: msKeg.produsen_data_id ? {
              id: msKeg.produsen_data_id,
              name: msKeg.produsen_data_name,
              province_code: msKeg.produsen_data_province_code,
              city_code: msKeg.produsen_data_city_code,
            } : null,
            walidata_pusat: msKeg.walidata_pusat_id ? {
              id: msKeg.walidata_pusat_id,
              name: msKeg.walidata_pusat_name,
            } : null,
            version: "v2",
            changes: null,
          };
          this.form.status =
            msKeg.status == "SUBMITTED" || msKeg.status == "REVISED"
              ? "UNDER_REVIEW"
              : msKeg.status;
          this.data = msKeg.data;
          if (this.data) {
            this.data.status = this.form.status;
          }
          this.formExt.getRecommendation = msKeg.data.identitas_rekomendasi
            ? true
            : false;
          if (msKeg.produsen_data_id) {
            this.formExt.produsenData = {
              id: msKeg.produsen_data_id,
              name: msKeg.produsen_data_name,
              provinceCode: msKeg.produsen_data_province_code,
              cityCode: msKeg.produsen_data_city_code,
            };
          }

          if (msKeg.version == "v1") {
            let keg = msKeg.data;
            this.data = {
              judul_kegiatan: keg.judulKegiatan,
              tahun: keg.tahun,
              jenis_statistik: msKeg.statistic_type,
              cara_pengumpulan_data: keg.caraPengumpulanData,
              sektor_kegiatan: keg.sektorKegiatan,
              identitas_rekomendasi: null,
              blok_i: {
                instansi_penyelanggara: keg.blokI.instansiPenyelanggara,
                alamat_instansi_penyelenggara: {
                  alamat: keg.blokI.alamatLengkapInstansiPenyelenggara,
                  telepon: keg.blokI.telepon,
                  email: keg.blokI.email,
                  faksimile: keg.blokI.faksimile,
                },
              },
              blok_ii: {
                unit_penanggung_jawab: {
                  eselon1: keg.blokII.unitPenanggungJawabEselon1,
                  eselon2: keg.blokII.unitPenanggungJawabEselon2,
                },
                penanggung_jawab_teknis: {
                  nama: keg.blokII.namaPenanggungJawabTeknis,
                  jabatan: keg.blokII.jabatanPenanggungJawabTeknis,
                  alamat: keg.blokII.alamatPenanggungJawabTeknis,
                  telepon: keg.blokII.teleponPenanggungJawabTeknis,
                  email: keg.blokII.emailPenanggungJawabTeknis,
                  faksimile: keg.blokII.faksimilePenanggungJawabTeknis,
                },
              },
              blok_iii: {
                latar_belakang_kegiatan: keg.blokIII.latarBelakangKegiatan,
                tujuan_kegiatan: keg.blokIII.tujuanKegiatan,
                rencana_jadwal_kegiatan: {
                  perencanaan_kegiatan:
                    keg.blokIII.rencanaJadwalKegiatan.perencanaanKegiatan.map(
                      (x) => ({
                        awal: moment(x.awal).format("YYYY-MM-DD"),
                        akhir: moment(x.akhir).format("YYYY-MM-DD"),
                      })
                    ),
                  desain: keg.blokIII.rencanaJadwalKegiatan.desain.map((x) => ({
                    awal: moment(x.awal).format("YYYY-MM-DD"),
                    akhir: moment(x.akhir).format("YYYY-MM-DD"),
                  })),
                  pengumpulan_data:
                    keg.blokIII.rencanaJadwalKegiatan.pengumpulanData.map(
                      (x) => ({
                        awal: moment(x.awal).format("YYYY-MM-DD"),
                        akhir: moment(x.akhir).format("YYYY-MM-DD"),
                      })
                    ),
                  pengolahan_data:
                    keg.blokIII.rencanaJadwalKegiatan.pengolahanData.map(
                      (x) => ({
                        awal: moment(x.awal).format("YYYY-MM-DD"),
                        akhir: moment(x.akhir).format("YYYY-MM-DD"),
                      })
                    ),
                  analisis: keg.blokIII.rencanaJadwalKegiatan.analisis.map(
                    (x) => ({
                      awal: moment(x.awal).format("YYYY-MM-DD"),
                      akhir: moment(x.akhir).format("YYYY-MM-DD"),
                    })
                  ),
                  diseminasi_hasil:
                    keg.blokIII.rencanaJadwalKegiatan.diseminasiHasil.map(
                      (x) => ({
                        awal: moment(x.awal).format("YYYY-MM-DD"),
                        akhir: moment(x.akhir).format("YYYY-MM-DD"),
                      })
                    ),
                  evaluasi: keg.blokIII.rencanaJadwalKegiatan.evaluasi.map(
                    (x) => ({
                      awal: moment(x.awal).format("YYYY-MM-DD"),
                      akhir: moment(x.akhir).format("YYYY-MM-DD"),
                    })
                  ),
                },
                variabel_yang_dikumpulkan:
                  keg.blokIII.variabelYangDikumpulkan.map((x) => ({
                    nama: x.nama,
                    konsep: x.konsep,
                    definisi: x.definisi,
                    referensi_waktu: x.referensiWaktu,
                  })),
              },
              blok_iv: {
                kegiatan_ini_dilakukan: keg.blokIV.kegiatanIniDilakukan,
                frekuensi_penyelanggara: keg.blokIV.frekuensiPenyelanggara,
                tipe_pengumpulan_data: keg.blokIV.tipePengumpulanData,
                cakupan_wilayah_pengumpulan_data:
                  keg.blokIV.cakupanWilayahPengumpulanData,
                sebagian_cakupan_wilayah_pengumpulan_data: [],
                metode_pengumpulan_data: {
                  wawancara: keg.blokIV.metodePengumpulanData.wawancara,
                  mengisi_kuesioner_sendiri:
                    keg.blokIV.metodePengumpulanData.mengisiKuesionerSendiri,
                  pengamatan: keg.blokIV.metodePengumpulanData.pengamatan,
                  pengumpulan_data_sekunder:
                    keg.blokIV.metodePengumpulanData.pengumpulanDataSekunder,
                  lainnya: keg.blokIV.metodePengumpulanData.lainnya,
                  metode_pengumpulan_lainnya: keg.blokIV.metodePengumpulanData
                    .metodePengumpulanLainnya
                    ? keg.blokIV.metodePengumpulanData.metodePengumpulanLainnya
                    : null,
                },
                sarana_pengumpulan_data: {
                  papi: keg.blokIV.saranaPengumpulanData.papi,
                  capi: keg.blokIV.saranaPengumpulanData.capi,
                  cati: keg.blokIV.saranaPengumpulanData.cati,
                  cawi: keg.blokIV.saranaPengumpulanData.cawi,
                  mail: keg.blokIV.saranaPengumpulanData.mail,
                  lainnya: keg.blokIV.saranaPengumpulanData.lainnya,
                  sarana_pengumpulan_lainnya: keg.blokIV.saranaPengumpulanData
                    .saranaPengumpulanLainnya
                    ? keg.blokIV.saranaPengumpulanData.saranaPengumpulanLainnya
                    : null,
                },
                unit_pengumpulan_data: {
                  individu: keg.blokIV.unitPengumpulanData.individu,
                  rumah_tangga: keg.blokIV.unitPengumpulanData.rumahTangga,
                  usaha_atau_perusahaan:
                    keg.blokIV.unitPengumpulanData.usahaAtauPerusahaan,
                  lainnya: keg.blokIV.unitPengumpulanData.lainnya,
                  unit_pengumpulan_data_lainnya: keg.blokIV.unitPengumpulanData
                    .unitPengumpulanDataLainnya
                    ? keg.blokIV.unitPengumpulanData.unitPengumpulanDataLainnya
                    : null,
                },
              },
              blok_v: {
                jenis_rancangan_sampel: keg.blokV.jenisRancanganSampel,
                metode_pemilihan_sampel_tahap_terakhir:
                  keg.blokV.metodePemilihanSampelTahapTerakhir,
                metode_yang_digunakan:
                  keg.blokV.metodeYangdigunakan == "MULTI_STAGE_SAMPLING"
                    ? "PROBABILTY_PROPORTIONAL_TO_SIZE_SAMPLING"
                    : keg.blokV.metodeYangdigunakan,
                kerangka_sampel_tahap_terakhir:
                  keg.blokV.kerangkaSampelTahapTerakhir,
                fraksi_sampel_keseluruhan: keg.blokV.fraksiSampelKeseluruhan,
                nilai_perkiraan_sampling_error_variabel_utama:
                  keg.blokV.nilaiPerkiraanSamplingErrorVariabelUtama,
                unit_sampel: keg.blokV.unitSampel,
                unit_observasi: keg.blokV.unitObservasi,
              },
              blok_vi: {
                apakah_melakukan_uji_coba: keg.blokVI.apakahMelakukanUjiCoba,
                metode_pemeriksaan_kualitas_pengumpulan_data: {
                  kunjungan_kembali:
                    keg.blokVI.metodePemeriksaanKualitasPengumpulanData
                      .kunjunganKembali,
                  supervisi:
                    keg.blokVI.metodePemeriksaanKualitasPengumpulanData
                      .supervisi,
                  taskforce:
                    keg.blokVI.metodePemeriksaanKualitasPengumpulanData
                      .taskforce,
                  lainnya:
                    keg.blokVI.metodePemeriksaanKualitasPengumpulanData.lainnya,
                  metode_pemeriksaan_kualitas_pengumpulan_data_lainnya: keg
                    .blokVI.metodePemeriksaanKualitasPengumpulanData
                    .metodePemeriksaanKualitasPengumpulanDataLainnya
                    ? keg.blokVI.metodePemeriksaanKualitasPengumpulanData
                        .metodePemeriksaanKualitasPengumpulanDataLainnya
                    : null,
                },
                apakah_melakukan_penyesuaian_nonrespon:
                  keg.blokVI.apakahMelakukanPenyesuaianNonrespon,
                petugas_pengumpulan_data: keg.blokVI.petugasPengumpulanData,
                persyaratan_pendidikan_terendah_petugas_pengumpulan_data:
                  keg.blokVI
                    .persyaratanPendidikanTerendahPetugasPengumpulanData,
                jumlah_petugas_supervisor: keg.blokVI.jumlahPetugasSupervisor,
                jumlah_petugas_enumerator: keg.blokVI.jumlahPetugasEnumerator,
                apakah_melakukan_pelatihan_petugas:
                  keg.blokVI.apakahMelakukanPelatihanPetugas,
              },
              blok_vii: {
                tahapan_pengolahan_data: {
                  editing: keg.blokVII.tahapanPengolahanData.udi,
                  coding: keg.blokVII.tahapanPengolahanData.udi,
                  data_entry: keg.blokVII.tahapanPengolahanData.udi,
                  validasi: keg.blokVII.tahapanPengolahanData.udi,
                },
                metode_analisis: keg.blokVII.metodeAnalisis,
                unit_analsis: {
                  individu: keg.blokVII.unitAnalsis.individu,
                  rumah_tangga: keg.blokVII.unitAnalsis.rumahTangga,
                  usaha_atau_perusahaan:
                    keg.blokVII.unitAnalsis.usahaAtauPerusahaan,
                  lainnya: keg.blokVII.unitAnalsis.lainnya,
                  unit_analisis_lainnya: keg.blokVII.unitAnalsis
                    .unitAnalisisLainnya
                    ? keg.blokVII.unitAnalsis.unitAnalisisLainnya
                    : null,
                },
                tingkat_penyajian_hasil_analisis: {
                  nasional: keg.blokVII.tingkatPenyajianHasilAnalisis.nasional,
                  provinsi: keg.blokVII.tingkatPenyajianHasilAnalisis.provinsi,
                  kabupaten_atau_kota:
                    keg.blokVII.tingkatPenyajianHasilAnalisis.kabupatenAtauKota,
                  kecamatan:
                    keg.blokVII.tingkatPenyajianHasilAnalisis.kecamatan,
                  lainnya: keg.blokVII.tingkatPenyajianHasilAnalisis.lainnya,
                  tingkat_penyajian_hasil_analisis_lainnya: keg.blokVII
                    .tingkatPenyajianHasilAnalisis
                    .tingkatPenyajianHasilAnalisisLainnya
                    ? keg.blokVII.tingkatPenyajianHasilAnalisis
                        .tingkatPenyajianHasilAnalisisLainnya
                    : null,
                },
              },
              blok_viii: {
                ketersediaan_produk_tercetak:
                  keg.blokVIII.ketersediaanProdukTercetak,
                ketersediaan_produk_digital:
                  keg.blokVIII.ketersediaanProdukDigital,
                ketersediaan_produk_mikrodata:
                  keg.blokVIII.ketersediaanProdukMikrodata,
                rencana_jadwal_rilis_produk_tercetak: keg.blokVIII
                  .ketersediaanProdukTercetak
                  ? keg.blokVIII.rencanaJadwalRilisProdukTercetak.map((x) =>
                      moment(x.tanggalRilis).format("YYYY-MM-DD")
                    )
                  : null,
                rencana_jadwal_rilis_produk_digital: keg.blokVIII
                  .ketersediaanProdukDigital
                  ? keg.blokVIII.rencanaJadwalRilisProdukDigital.map((x) =>
                      moment(x.tanggalRilis).format("YYYY-MM-DD")
                    )
                  : null,
                rencana_jadwal_rilis_produk_mikrodata: keg.blokVIII
                  .ketersediaanProdukMikrodata
                  ? keg.blokVIII.rencanaJadwalRilisProdukMikrodata.map((x) =>
                      moment(x.tanggalRilis).format("YYYY-MM-DD")
                    )
                  : null,
              },
            };

            if (
              this.data.blok_iv.cakupan_wilayah_pengumpulan_data ==
              "SEBAGIAN_WILAYAH_INDONESIA"
            ) {
              this.formExt.wilayah =
                keg.blokIV.sebagianCakupanWilayahPengumpulanData.map((item) => {
                  let city = this.options.city.find(
                    (x) => x.name == item.kabupatenKota
                  );
                  if (city !== undefined) {
                    return {
                      id: city.id,
                      name: city.name,
                      province_id: city.province_id,
                      province_name: city.province_name,
                    };
                  }
                });
            }
          }
          if (this.route == "CycleMsKeg") {
            this.form = {
              base_id: null,
              submission_period: new Date().getFullYear(),
              data: null,
              reviews: null,
              status: "DRAFT",
              rejection_note: null,
              submitter: null,
              produsen_data: null,
              walidata_pusat: null,
              version: "v2",
              changes: null,
            };
          }
          // ;
        },
        (error) => {
          console.error(error);
        }
      );
    },
    async validateForm() {
      let index = this.section.currentIndex;
      if (index == 0) {
        this.section.items[index].status =
          (await this.$refs.halamanAwalObserver.validate())
            ? "valid"
            : "invalid";
      }
      if (index == 1) {
        this.section.items[index].status =
          (await this.$refs.blokIObserver.validate()) ? "valid" : "invalid";
      }
      if (index == 2) {
        this.section.items[index].status =
          (await this.$refs.blokIIObserver.validate()) ? "valid" : "invalid";
      }
      if (index == 3) {
        this.section.items[index].status =
          (await this.$refs.blokIIIObserver.validate()) ? "valid" : "invalid";
      }
      if (index == 4) {
        this.section.items[index].status =
          (await this.$refs.blokIVObserver.validate()) ? "valid" : "invalid";
      }
      if (index == 5) {
        this.section.items[index].status =
          (await this.$refs.blokVObserver.validate()) ? "valid" : "invalid";
      }
      if (index == 6) {
        this.section.items[index].status =
          (await this.$refs.blokVIObserver.validate()) ? "valid" : "invalid";
      }
      if (index == 7) {
        this.section.items[index].status =
          (await this.$refs.blokVIIObserver.validate()) ? "valid" : "invalid";
      }
      if (index == 8) {
        this.section.items[index].status =
          (await this.$refs.blokVIIIObserver.validate()) ? "valid" : "invalid";
      }
    },
    async validateAll() {
      this.section.items[0].status =
        (await this.$refs.halamanAwalObserver.validate()) ? "valid" : "invalid";
      this.section.items[1].status = (await this.$refs.blokIObserver.validate())
        ? "valid"
        : "invalid";
      this.section.items[2].status =
        (await this.$refs.blokIIObserver.validate()) ? "valid" : "invalid";
      this.section.items[3].status =
        (await this.$refs.blokIIIObserver.validate()) ? "valid" : "invalid";
      this.section.items[4].status =
        (await this.$refs.blokIVObserver.validate()) ? "valid" : "invalid";
      if (this.data.cara_pengumpulan_data == "SURVEI") {
        this.section.items[5].status =
          (await this.$refs.blokVObserver.validate()) ? "valid" : "invalid";
      }
      this.section.items[6].status =
        (await this.$refs.blokVIObserver.validate()) ? "valid" : "invalid";
      this.section.items[7].status =
        (await this.$refs.blokVIIObserver.validate()) ? "valid" : "invalid";
      this.section.items[8].status =
        (await this.$refs.blokVIIIObserver.validate()) ? "valid" : "invalid";
    },
    async save() {
      await this.validateAll();
      let status = this.form.status;
      let isError =
        this.section.items.filter((x) => x.status == "invalid").length > 0;

      if (status == "DRAFT") {
        if (
          this.form.data.judul_kegiatan == null ||
          this.form.data.tahun == null ||
          this.formExt.produsenData == null
        ) {
          this.modal.error.title = "Isian Error";
          this.modal.error.description =
            'Untuk dapat menyimpan dalam bentuk DRAFT, minimal isian <span class="text-primary">Nama Kegiatan, Tahun kegiatan & Instansi Penyelanggara</span> tidak boleh kosong';
          this.$bvModal.show("modal-error");
        } else {
          this.sendData();
        }
      } else {
        if (isError) {
          this.modal.error.title = "Isian Error";
          this.modal.error.description =
            "Untuk dapat melakukan submit, pastikan tidak ada lagi isian yang error";
          this.$bvModal.show("modal-error");
        } else {
          this.sendData();
        }
      }
    },
    async sendData() {
      this.$bvModal.show("modal-saving");
      this.saveState = "SAVING";
      this.form.id = this.updatedId;
      if (this.data) {
        this.data.status = this.form.status;
      }
      this.form.data = this.data;
      if (this.formExt && this.formExt.produsenData) {
        this.form.produsen_data = {
          id: this.formExt.produsenData.id,
          name: this.formExt.produsenData.name,
          province_code: this.formExt.produsenData.provinceCode || this.formExt.produsenData.province_code,
          city_code: this.formExt.produsenData.cityCode || this.formExt.produsenData.city_code,
        };
      }
      if (this.form.status == "REJECTED") {
        this.form.rejection_note = this.rejectionNote;
      }
      MsService.updateMsKeg(this.form, this.updatedId).then(
        (result) => {
          let resData = result.data || {};
          let itemRes = (resData.result && resData.result[0]) ? resData.result[0] : resData;
          if (itemRes && (itemRes.status == 403 || itemRes.status == 500)) {
            if (itemRes.status == 403) {
              this.modal.error.title = "Forbidden";
              this.modal.error.description =
                "Anda tidak mempunyai akses untuk mengupdate item";
            } else {
              this.modal.error.title = itemRes.title || "Error";
              this.modal.error.description = itemRes.detail || "Terjadi kesalahan saat mengupdate item";
            }
            this.$bvModal.hide("modal-saving");
            this.$bvModal.show("modal-error");
          } else {
            this.saveState = "SUCCESS";
            this.delay(2000).then(() =>
              this.$router.push("/metadata/pemeriksaan")
            );
          }
        },
        (error) => {
          this.saveState = "ERROR";
          this.saveError = error.response;
        }
      );
    },
    async loadRekomendasi() {
      this.$bvModal.show("modal-loading");
      await rekomendasiService.getData(this.data.identitas_rekomendasi).then(
        (response) => {
          this.rekomendasi = response.data.result[0];
          if (this.rekomendasi.status == "1") {
            this.mappingRekomendasi(this.rekomendasi.data);
          }
        },
        (error) => {
          this.data =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
      this.$bvModal.hide("modal-loading");
    },
    mappingRekomendasi(rekomendasi) {
      this.data.judul_kegiatan = rekomendasi.judul
        ? rekomendasi.judul
        : rekomendasi.Judul;
      this.data.tahun = null;
      this.data.jenis_statistik = "STATISTIK_SEKTORAL";
      (this.data.cara_pengumpulan_data =
        rekomendasi.Cara_Pengumpulan_Data == "SEBAGIAN POPULASI (SAMPEL)"
          ? "SURVEI"
          : rekomendasi.Jenis_Kegiatan == "Kompromin"
          ? "KOMPILASI_PRODUK_ADMINISTRASI"
          : null),
        (this.data.sektor_kegiatan = null);
      (this.data.identitas_rekomendasi = rekomendasi.nomor_rekomendasi
        ? rekomendasi.nomor_rekomendasi
        : rekomendasi.Nomor_Rekomendasi),
        (this.data.blok_ii = {
          unit_penanggung_jawab: {
            eselon1: null,
            eselon2: null,
          },
          penanggung_jawab_teknis: {
            nama: rekomendasi.Nama_Manajer_Survei,
            jabatan: rekomendasi.Jabatan_Manajer_Survei,
            alamat: rekomendasi.Alamat_Manajer_Survei,
            telepon: rekomendasi.Telepon_Manajer_Survei,
            email: rekomendasi["E-mail_Manajer_Survei"],
            faksimile: rekomendasi.Fax_Manajer_Survei,
          },
        }),
        (this.data.blok_iii = {
          latar_belakang_kegiatan: null,
          tujuan_kegiatan: rekomendasi.Tujuan_Survei
            ? rekomendasi.Tujuan_Survei
            : rekomendasi.Tujuan_Dan_Manfaat_Kegiatan,
          rencana_jadwal_kegiatan: {
            perencanaan_kegiatan: [
              {
                awal: rekomendasi.Perencanaan_Persiapan_Mulai,
                akhir: rekomendasi.Perencanaan_Persiapan_Selesai,
              },
            ],
            desain: [
              {
                awal: null,
                akhir: null,
              },
            ],
            pengumpulan_data: [
              {
                awal: rekomendasi.Pelaksanaan_Lapangan_Mulai
                  ? rekomendasi.Pelaksanaan_Lapangan_Mulai
                  : rekomendasi.Pengumpulan_Data_Mulai,
                akhir: rekomendasi.Pelaksanaan_Lapangan_Selesai
                  ? rekomendasi.Pelaksanaan_Lapangan_Selesai
                  : rekomendasi.Pengumpulan_Data_Selesai,
              },
            ],
            pengolahan_data: [
              {
                awal: rekomendasi.Pengolahan_Mulai,
                akhir: rekomendasi.Pengolahan_Selesai,
              },
            ],
            analisis: [
              {
                awal: rekomendasi.Analisis_Mulai,
                akhir: rekomendasi.Analisis_Selesai,
              },
            ],
            diseminasi_hasil: [
              {
                awal: rekomendasi.Penyajian_Mulai
                  ? rekomendasi.Penyajian_Mulai
                  : rekomendasi.Diseminasi_Mulai,
                akhir: rekomendasi.Penyajian_Selesai
                  ? rekomendasi.Penyajian_Selesai
                  : rekomendasi.Diseminasi_Selesai,
              },
            ],
            evaluasi: [
              {
                awal: null,
                akhir: null,
              },
            ],
          },
          variabel_yang_dikumpulkan:
            rekomendasi.Variabel && rekomendasi.Variabel.length > 0
              ? rekomendasi.Variabel.map((x) => ({
                  nama: x.nama,
                  konsep: null,
                  definisi: null,
                  referensi_waktu: x.referensi_waktu,
                }))
              : [
                  {
                    nama: null,
                    konsep: null,
                    definisi: null,
                    referensi_waktu: null,
                  },
                ],
        });
      let kegiatan_ini_dilakukan = rekomendasi.Survei_ini_dilakukan
        ? rekomendasi.Survei_ini_dilakukan
        : rekomendasi.Kegiatan_Ini_Dilakukan.value;
      let frekuensi = rekomendasi.Jika_Berulang_Frekuensi_Penyelenggaraan
        ? rekomendasi.Jika_Berulang_Frekuensi_Penyelenggaraan
        : rekomendasi.Frekuensi_Penyelenggaraan_Kegiatan.value.toUpperCase();
      let cakupan_wilayah_pengumpulan_data = rekomendasi.Survei_dilakukan_di
        ? rekomendasi.Survei_dilakukan_di
        : rekomendasi.Cakupan_Wilayah_Data.value;
      let metode_pengumpulan_data = Array.isArray(
        rekomendasi.Metode_Pengumpulan_Data
      )
        ? rekomendasi.Metode_Pengumpulan_Data.map((x) => x.value).join(" ")
        : rekomendasi.Metode_Pengumpulan_Data
        ? rekomendasi.Metode_Pengumpulan_Data
        : null;
      let metode_pengumpulan_data_lainnya =
        metode_pengumpulan_data &&
        !metode_pengumpulan_data
          .toLowerCase()
          .includes(
            "wawancara",
            "mengisi kuesioner sendiri",
            "pengamatan",
            "data sekunder"
          )
          ? metode_pengumpulan_data
          : null;
      if (rekomendasi.Metode_Pengumpulan_Data_Lainnya) {
        metode_pengumpulan_data_lainnya +=
          " " + rekomendasi.Metode_Pengumpulan_Data_Lainnya;
      }
      let tipe_pengumpulan_data = rekomendasi.Tipe_Pengumpulan_Data
        ? rekomendasi.Tipe_Pengumpulan_Data
        : rekomendasi.Tipe_Pengumpulan_Data_Kegiatan
        ? rekomendasi.Tipe_Pengumpulan_Data_Kegiatan.value
        : null;
      let mapped_tipe_pengumpulan_data = null;
      if (
        tipe_pengumpulan_data === "LONGITUDINAL" ||
        tipe_pengumpulan_data === "Longitudinal Panel" ||
        tipe_pengumpulan_data === "LONGITUDINAL_PANEL"
      ) {
        mapped_tipe_pengumpulan_data = "LONGITUDINAL_PANEL";
      } else if (
        tipe_pengumpulan_data === "Longitudinal Cross Sectional" ||
        tipe_pengumpulan_data === "LONGITUDINAL_CROSS_SECTIONAL" ||
        tipe_pengumpulan_data === "LONGITUDINAL DAN CROSS SECTIONAL" ||
        tipe_pengumpulan_data === "Series dan cross section"
      ) {
        mapped_tipe_pengumpulan_data = "LONGITUDINAL_CROSS_SECTIONAL";
      } else if (
        tipe_pengumpulan_data === "cross_sectional" ||
        tipe_pengumpulan_data === "CROSS_SECTIONAL" ||
        tipe_pengumpulan_data === "Cross Sectional"
      ) {
        mapped_tipe_pengumpulan_data = "CROSS_SECTIONAL";
      } else {
        mapped_tipe_pengumpulan_data = null;
      }
      this.data.blok_iv = {
        kegiatan_ini_dilakukan: ["BERULANG", "Berulang"].includes(
          kegiatan_ini_dilakukan
        )
          ? "BERULANG"
          : "HANYA_SEKALI",
        frekuensi_penyelanggara:
          frekuensi == "LAINNYA" ? "LEBIH_DARI_DUA_TAHUNAN" : frekuensi,
        tipe_pengumpulan_data: mapped_tipe_pengumpulan_data,
        cakupan_wilayah_pengumpulan_data: [
          "SEBAGIAN WILAYAH INDONESIA",
          "Sebagian wilayah Indonesia",
        ].includes(cakupan_wilayah_pengumpulan_data)
          ? "SEBAGIAN_WILAYAH_INDONESIA"
          : "SELURUH_WILAYAH_INDONESIA",
        sebagian_cakupan_wilayah_pengumpulan_data: [],
        metode_pengumpulan_data: {
          wawancara: metode_pengumpulan_data.toLowerCase().includes("wawancara")
            ? true
            : false,
          mengisi_kuesioner_sendiri: metode_pengumpulan_data
            .toLowerCase()
            .includes("mengisi kuesioner sendiri")
            ? true
            : false,
          pengamatan: metode_pengumpulan_data
            .toLowerCase()
            .includes("pengamatan")
            ? true
            : false,
          pengumpulan_data_sekunder: false,
          lainnya: metode_pengumpulan_data_lainnya ? true : false,
          metode_pengumpulan_lainnya: metode_pengumpulan_data_lainnya
            ? metode_pengumpulan_data_lainnya
            : null,
        },
        sarana_pengumpulan_data: {
          papi: true,
          capi: false,
          cati: false,
          cawi: false,
          mail: false,
          lainnya: false,
          sarana_pengumpulan_lainnya: null,
        },
        unit_pengumpulan_data: {
          individu: true,
          rumah_tangga: false,
          usaha_atau_perusahaan: false,
          lainnya: false,
          unit_pengumpulan_data_lainnya: null,
        },
      };
      let sebagian_cakupan_wilayah_pengumpulan_data =
        rekomendasi.Wilayah_Data_New
          ? rekomendasi.Wilayah_Data_New
          : rekomendasi.Wilayah_Data;
      if (
        this.data.blok_iv.cakupan_wilayah_pengumpulan_data ==
        "SEBAGIAN_WILAYAH_INDONESIA"
      ) {
        this.formExt.wilayah = sebagian_cakupan_wilayah_pengumpulan_data.map(
          (x) => ({
            id: x.kode_kabkot,
            name: x.kabkot,
            province_id: x.kode_provinsi,
            province_name: x.provinsi,
          })
        );
      }

      if (this.data.cara_pengumpulan_data == "SURVEI") {
        let metode_yang_digunakan =
          rekomendasi.Metode_Penelitian == "SAMPEL NON PROBABILITAS"
            ? rekomendasi.Metode_untuk_Sampel_Non_Probabilitas.toUpperCase()
            : rekomendasi.Metode_pemilihan_sampel.toUpperCase();
        if (metode_yang_digunakan.includes("Simple Random")) {
          metode_yang_digunakan = "SIMPLE_RANDOM_SAMPLING";
        } else if (metode_yang_digunakan.includes("Systematic")) {
          metode_yang_digunakan = "SYSTEMATIC_RANDOM_SAMPLING";
        } else if (metode_yang_digunakan.includes("Stratified")) {
          metode_yang_digunakan = "STRATIFIED_RANDOM_SAMPLING";
        } else if (metode_yang_digunakan.includes("Cluster")) {
          metode_yang_digunakan = "CLUSTER_SAMPLING";
        } else if (metode_yang_digunakan.includes("Multi Stage")) {
          metode_yang_digunakan = "MULTI_STAGE_SAMPLING";
        } else if (metode_yang_digunakan.includes("Quota")) {
          metode_yang_digunakan = "QUOTA_SAMPLING";
        } else if (metode_yang_digunakan.includes("Accidental")) {
          metode_yang_digunakan = "ACCIDENTAL_SAMPLING";
        } else if (metode_yang_digunakan.includes("Purposive")) {
          metode_yang_digunakan = "PURPOSIVE_SAMPLING";
        } else if (metode_yang_digunakan.includes("Snowball")) {
          metode_yang_digunakan = "SNOWBALL_SAMPLING";
        } else if (metode_yang_digunakan.includes("Saturation")) {
          metode_yang_digunakan = "SATURATION_SAMPLING";
        } else {
          metode_yang_digunakan = null;
        }
        this.data.blok_v = {
          jenis_rancangan_sampel:
            rekomendasi.Jenis_Rancangan_Sampel == "SINGLE STAGE/PHASE"
              ? "SINGLE_STAGE_ATAU_PHASE"
              : "MULTI_STAGE_ATAU_PHASE",
          metode_pemilihan_sampel_tahap_terakhir:
            rekomendasi.Metode_Penelitian == "SAMPEL NON PROBABILITAS"
              ? "SAMPEL_NONPROBABILITAS"
              : "SAMPEL_PROBABILITAS",
          metode_yang_digunakan: metode_yang_digunakan,
          kerangka_sampel_tahap_terakhir: "LIST_FRAME",
          fraksi_sampel_keseluruhan: rekomendasi.Keseluruhan_fraksi_sampel,
          nilai_perkiraan_sampling_error_variabel_utama:
            rekomendasi.Perkiraan_sampling_error,
          unit_sampel: rekomendasi.Unit_sampel,
          unit_observasi: null,
        };
      }
      let petugas_pengumpulan_data = Array.isArray(
        rekomendasi.Petugas_Pengumpulan_Data
      )
        ? rekomendasi.Petugas_Pengumpulan_Data.map((x) => x.value).join(" ")
        : rekomendasi.Petugas_Pengumpul_Data;
      let persyaratan_pendidikan_terendah_petugas_pengumpulan_data =
        rekomendasi.Persyaratan_pendidikan_terendah_petugas_pengumpulan_data
          ? rekomendasi.Persyaratan_pendidikan_terendah_petugas_pengumpulan_data
              .value
          : rekomendasi.Persyaratan_pendidikan_terendah_petugas_pengumpul_data;

      this.data.blok_vi = {
        apakah_melakukan_uji_coba:
          rekomendasi.Apakah_melakukan_Uji_Coba == "Tidak" ? false : true,
        metode_pemeriksaan_kualitas_pengumpulan_data: {
          kunjungan_kembali: true,
          supervisi: false,
          taskforce: false,
          lainnya: false,
          metode_pemeriksaan_kualitas_pengumpulan_data_lainnya: null,
        },
        apakah_melakukan_penyesuaian_nonrespon: true,
        petugas_pengumpulan_data: petugas_pengumpulan_data.includes("LAINNYA")
          ? null
          : petugas_pengumpulan_data.includes("STAF", "Staf")
          ? "STAF_INSTANSI_PENYELENGGARA"
          : "MITRA_ATAU_TENAGA_KONTRAK",

        persyaratan_pendidikan_terendah_petugas_pengumpulan_data:
          persyaratan_pendidikan_terendah_petugas_pengumpulan_data.includes(
            "SMK"
          )
            ? "SMA_ATAU_SMK"
            : persyaratan_pendidikan_terendah_petugas_pengumpulan_data
                .toLowerCase()
                .includes("akademi")
            ? "DIPLOMA_I_ATAU_II_ATAU_III"
            : "KURANG_DARI_ATAU_SAMA_DENGAN_SMP",
        jumlah_petugas_supervisor: rekomendasi.Supervisor_Penyelia_Pengawas
          ? parseInt(
              rekomendasi.Supervisor_Penyelia_Pengawas.replace(" orang", "")
            )
          : parseInt(
              rekomendasi.Supervisi_Penyelia_Pengawas.replace(" orang", "")
            ),
        jumlah_petugas_enumerator: rekomendasi.PengumpulData_Enumerator
          ? parseInt(rekomendasi.PengumpulData_Enumerator.replace(" orang", ""))
          : parseInt(
              rekomendasi.Enumerator_Kompilator_Pengumpuldata.replace(
                " orang",
                ""
              )
            ),
        apakah_melakukan_pelatihan_petugas:
          rekomendasi.Apakah_melakukan_pelatihan_petugas
            ? rekomendasi.Apakah_melakukan_pelatihan_petugas.trim()
                .substring(0, 2)
                .toUpperCase() == "YA"
              ? true
              : false
            : rekomendasi.Apakah_Melakukan_Pelatihan_Petugas_Pengumpulandata.trim()
                .substring(0, 2)
                .toUpperCase() == "YA"
            ? true
            : false,
      };
      let tingkat_penyajian_hasil_analisis = rekomendasi.Tingkat_Penyajian_Data
        ? rekomendasi.Tingkat_Penyajian_Data.map((x) => x.id)
        : [];
      let metode_analisis = rekomendasi.Metode_analisis_hasil_survei
        ? rekomendasi.Metode_analisis_hasil_survei
        : rekomendasi.Metode_Analisis;
      this.data.blok_vii = {
        tahapan_pengolahan_data: {
          editing: rekomendasi.Penyuntingan == "Ya" ? true : false,
          coding: rekomendasi.Penyandian == "Ya" ? true : false,
          data_entry:
            rekomendasi.Inputdata && rekomendasi.Inputdata == "Ya"
              ? true
              : false,
          validasi: rekomendasi.Penyahihan == "Ya" ? true : false,
        },
        metode_analisis: metode_analisis.toLowerCase().includes("inferensia")
          ? "INFERENSIA"
          : "DESKRIPTIF",
        unit_analsis: {
          individu: false,
          rumah_tangga: false,
          usaha_atau_perusahaan: false,
          lainnya: rekomendasi.Unit_Analisis ? true : false,
          unit_analisis_lainnya: rekomendasi.Unit_Analisis
            ? rekomendasi.Unit_Analisis
            : null,
        },
        tingkat_penyajian_hasil_analisis: {
          nasional: tingkat_penyajian_hasil_analisis.includes("1")
            ? true
            : false,
          provinsi: tingkat_penyajian_hasil_analisis.includes("2")
            ? true
            : false,
          kabupaten_atau_kota: tingkat_penyajian_hasil_analisis.includes("4")
            ? true
            : false,
          kecamatan: tingkat_penyajian_hasil_analisis.includes("8")
            ? true
            : false,
          lainnya: tingkat_penyajian_hasil_analisis.includes("16")
            ? true
            : false,
          tingkat_penyajian_hasil_analisis_lainnya:
            tingkat_penyajian_hasil_analisis.includes("16")
              ? rekomendasi.Tingkat_Penyajian_Data_Lainnya
              : null,
        },
      };
      let ketersediaan_produk_tercetak = rekomendasi.Publikasi_dalam_Media_Cetak
        ? rekomendasi.Publikasi_dalam_Media_Cetak
        : rekomendasi.Publikasi_Tercetak;
      let ketersediaan_produk_digital =
        rekomendasi.Publikasi_dalam_Media_Elektronik
          ? rekomendasi.Publikasi_dalam_Media_Elektronik
          : rekomendasi.Publikasi_Elektronik;
      let ketersediaan_produk_mikrodata = rekomendasi.Micro_Data
        ? rekomendasi.Micro_Data
        : null;

      this.data.blok_viii = {
        ketersediaan_produk_tercetak:
          ketersediaan_produk_tercetak == "Ya" ? true : false,
        ketersediaan_produk_digital:
          ketersediaan_produk_digital == "Ya" ? true : false,
        ketersediaan_produk_mikrodata:
          ketersediaan_produk_mikrodata == "Ya" ? true : false,
        rencana_jadwal_rilis_produk_tercetak:
          ketersediaan_produk_tercetak == "Ya"
            ? [
                rekomendasi.Waktu_ketersediaan_hasil_survei_untuk_umum
                  ? this.formatDate(
                      rekomendasi.Waktu_ketersediaan_hasil_survei_untuk_umum
                    )
                  : this.formatDate(
                      rekomendasi.Rencana_Penerbitan_Publikasi_Untuk_Umum
                    ),
              ]
            : [],
        rencana_jadwal_rilis_produk_digital:
          ketersediaan_produk_digital == "Ya"
            ? [
                rekomendasi.Waktu_ketersediaan_hasil_survei_untuk_umum
                  ? this.formatDate(
                      rekomendasi.Waktu_ketersediaan_hasil_survei_untuk_umum
                    )
                  : this.formatDate(
                      rekomendasi.Rencana_Penerbitan_Publikasi_Untuk_Umum
                    ),
              ]
            : [],
        rencana_jadwal_rilis_produk_mikrodata:
          ketersediaan_produk_mikrodata == "Ya"
            ? [
                rekomendasi.Waktu_ketersediaan_hasil_survei_untuk_umum
                  ? this.formatDate(
                      rekomendasi.Waktu_ketersediaan_hasil_survei_untuk_umum
                    )
                  : this.formatDate(
                      rekomendasi.Rencana_Penerbitan_Publikasi_Untuk_Umum
                    ),
              ]
            : [],
      };
    },
    capitalize(sentence) {
      return sentence
        ? sentence
            .replaceAll("_", " ")
            .toLowerCase()
            .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
        : "-";
    },
    statusFormatterStyle(status) {
      return status ? status.toLowerCase().replace("_", "-") : "draft";
    },
    statusFormatter(status) {
      return status
        ? this.options.status.find((x) => x.id == status).label
        : "Draft";
    },
    changeQuesModeValue(att) {
      this.ques[att] = this.options[att].find(
        (x) => x.id == this.data[att]
      ).code;
    },
    changeEntriModeValue(att) {
      let value = this.options[att].find((x) => x.code == this.ques[att]);
      if (value) {
        this.data[att] = value.id;
      }
    },
    next() {
      if (this.section.currentIndex != this.section.items.length - 1) {
        this.validateForm();
        if (
          this.data.cara_pengumpulan_data != "SURVEI" &&
          this.section.currentIndex == 4
        ) {
          this.section.currentIndex += 2;
        } else {
          this.section.currentIndex =
            this.section.currentIndex == null
              ? 0
              : this.section.currentIndex + 1;
        }
      }
    },
    prev() {
      if (this.section.currentIndex != null) {
        if (
          this.data.cara_pengumpulan_data != "SURVEI" &&
          this.section.currentIndex == 6
        ) {
          this.section.currentIndex -= 2;
        } else {
          this.section.currentIndex =
            this.section.currentIndex == 0
              ? null
              : this.section.currentIndex - 1;
        }
      }
    },
    loadOptions({ callback }) {
      let result = "Sedang melakukan load data";
      callback(null, result);
    },

    async produsenDataLoadOptions({ searchQuery, callback }) {
      let name = searchQuery;
      let page = 0;
      let provinceCode = this.user.organization.province.code;
      let cityCode = this.user.organization.city.code;
      await SdsService.getProdusenData(page, name, provinceCode, cityCode).then(
        (result) => {
          let options = result.data.content;
          callback(null, options);
        },
        (error) => {
          console.log(error);
        }
      );
    },
    produsenDataNormalizer(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    scrollToUpperMost: function () {
      setTimeout(function () {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }, 100);
    },
    delay(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    formatDate(strinDate) {
      if (strinDate) {
        let bulan = [
          "Januari",
          "Februari",
          "Maret",
          "April",
          "Mei",
          "Juni",
          "Juli",
          "Agustus",
          "September",
          "Oktober",
          "November",
          "Desember",
        ];
        let val = strinDate.split(" ");
        let day = parseInt(val[0]);
        let month = bulan.indexOf(val[1]) + 1;
        let year = parseInt(val[2]);

        day = day < 10 ? "0" + day : day;
        month = month < 10 ? "0" + month : month;
        return year + "-" + month + "-" + day;
      }
    },
    wilayahNormalizer(node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      };
    },
    async setWilayah() {
      if (this.user.organization.province.code == "00") {
        this.options.userWilayah = this.options.wilayah;
      } else {
        this.options.userWilayah = this.options.wilayah.filter(
          (x) => x.code == this.user.organization.province.code
        );
      }
      this.options.userWilayah.forEach(async (prov) => {
        await WilayahService.getKabupatenKotaByIdProvinsi(prov.id).then(
          (response) => {
            let cities = response.data.data.map((x) => {
              let city = {
                id: x.kode,
                name: x.nama,
                province_id: prov.id,
                province_name: prov.name,
              };
              this.options.city.push(city);
              return city;
            });
            prov.children = cities;
          },
          (error) => {
            console.error(error);
          }
        );
      });
    },

    isCreatedByMe(item) {
      if (
        item.requested_by == this.$store.getters["auth/user"].username ||
        role.isSuperAdmin(this.userRoles)
      ) {
        return true;
      } else {
        return false;
      }
    },
    editable(item) {
      if (role.isSuperAdmin(this.userRoles)) {
        return true;
      } else {
        if (
          (item.status == "DRAFT" || item.status == "CORRECTION_REQUIRED") &&
          item.requested_by == this.$store.getters["auth/user"].username
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    deleteable(item) {
      if (role.isSuperAdmin(this.userRoles)) {
        return true;
      } else {
        if (
          item.status == "DRAFT" &&
          item.requested_by == this.$store.getters["auth/user"].username
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    tabIndexChanged(index) {
      this.tab.index = index;
      let msLastApproval = {
        ms_keg_id: this.msKeg.id,
        tab_index: index,
      };
      localStorage.msLastApproval = JSON.stringify(msLastApproval);
    },
    reviewFieldsName(field) {
      let fields = [];
      this.reviewFields.forEach((x) => {
        let field = {
          id: x.id,
          label: x.label,
        };
        fields.push(field);
        // console.log(x.children)
        if (x.children) {
          fields.concat(x.children);
        }
      });
      // console.log(fields)
      return fields.find((x) => x.id == field).label;
    },
  },
};
</script>
